import './index.scss';

export function AiIcon(props) {
    return (
        <svg height="60" width="62" viewBox="100 100 512 512" {...props}>
            <g>
                <path
                    className="icon-ai-path"
                    d="M430.518,436.027H176.945c-29.282,0-53.105-23.823-53.105-53.107V258.417 c0-29.282,23.823-53.105,53.105-53.105h253.573c29.282,0,53.105,23.823,53.105,53.105v124.503 C483.623,412.204,459.8,436.027,430.518,436.027z M176.945,232.988c-14.022,0-25.43,11.408-25.43,25.43v124.503 c0,14.023,11.408,25.431,25.43,25.431h253.573c14.022,0,25.43-11.408,25.43-25.431V258.417c0-14.022-11.408-25.43-25.43-25.43 L176.945,232.988L176.945,232.988z"
                />
                <path
                    className="icon-ai-path"
                    d="M247.551,364.987c0-0.399,0.134-0.93,0.266-1.463l24.706-81.029 c1.463-4.648,7.439-6.906,13.55-6.906c6.109,0,12.087,2.258,13.549,6.906l24.839,81.029c0.134,0.533,0.266,1.064,0.266,1.463 c0,4.915-7.572,8.502-13.284,8.502c-3.32,0-5.977-1.064-6.775-3.852l-4.517-16.604h-28.029l-4.517,16.604 c-0.797,2.79-3.453,3.852-6.775,3.852C255.122,373.487,247.551,369.902,247.551,364.987z M295.769,337.091l-9.696-35.599 l-9.698,35.599H295.769z"
                />
                <path
                    className="icon-ai-path"
                    d="M332.435,282.63c0-4.384,5.181-6.244,10.36-6.244c5.181,0,10.362,1.86,10.362,6.244v84.483 c0,4.25-5.181,6.375-10.362,6.375c-5.18,0-10.36-2.126-10.36-6.375V282.63z"
                />
            </g>
        </svg>
    );
}

export function ArrowIcon(props) {
    return (
        <svg viewBox="0 0 24 24" width="15px" height="15px" {...props}>
            <g>
                <path
                    className="icon-arrow"
                    d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
                ></path>
            </g>
        </svg>
    );
}

export function CodeIcon(props) {
    return (
        <svg width="30" height="50" viewBox="0 0 24 24" {...props}>
            <path
                className="icon-code-path"
                d="M14.9615 5.27473C15.1132 4.7437 14.8058 4.19021 14.2747 4.03849C13.7437 3.88677 13.1902 4.19426 13.0385 4.72529L9.03847 18.7253C8.88675 19.2563 9.19424 19.8098 9.72528 19.9615C10.2563 20.1133 10.8098 19.8058 10.9615 19.2747L14.9615 5.27473Z"
            />
            <path
                className="icon-code-path"
                d="M5.7991 7.39879C6.13114 7.84012 6.04255 8.46705 5.60123 8.7991L2.40894 11.2009C1.87724 11.601 1.87723 12.399 2.40894 12.7991L5.60123 15.2009C6.04255 15.533 6.13114 16.1599 5.7991 16.6012C5.46705 17.0426 4.84012 17.1311 4.39879 16.7991L1.20651 14.3973C-0.388615 13.1971 -0.388621 10.8029 1.2065 9.60276L4.39879 7.20093C4.84012 6.86889 5.46705 6.95747 5.7991 7.39879Z"
            />
            <path
                className="icon-code-path"
                d="M18.2009 16.6012C17.8689 16.1599 17.9575 15.533 18.3988 15.2009L21.5911 12.7991C22.1228 12.399 22.1228 11.601 21.5911 11.2009L18.3988 8.7991C17.9575 8.46705 17.8689 7.84012 18.2009 7.39879C18.533 6.95747 19.1599 6.86889 19.6012 7.20093L22.7935 9.60276C24.3886 10.8029 24.3886 13.1971 22.7935 14.3973L19.6012 16.7991C19.1599 17.1311 18.533 17.0426 18.2009 16.6012Z"
            />
        </svg>
    );
}

export function FullScreenIcon(props) {
    return (
        <svg
            className="icon-fullscreen"
            width="24"
            height="32"
            viewBox="0 0 24 24"
            {...props}
        >
            <path d="M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z" />
        </svg>
    );
}

export function FullScreenCloseIcon(props) {
    return (
        <svg
            className="icon-fullscreen"
            width="24"
            height="32"
            viewBox="0 0 24 24"
            {...props}
        >
            {/* <path d="M7 16L2 16C1.44772 16 1 15.5523 1 15C1 14.4477 1.44772 14 2 14L7 14C8.65685 14 10 15.3431 10 17V22C10 22.5523 9.55228 23 9 23C8.44772 23 8 22.5523 8 22V17C8 16.4477 7.55228 16 7 16Z" fill="#0F0F0F"></path> <path d="M10 2C10 1.44772 9.55229 1 9 1C8.44772 1 8 1.44772 8 2L8 7C8 7.55228 7.55228 8 7 8L2 8C1.44772 8 1 8.44771 1 9C1 9.55228 1.44772 10 2 10L7 10C8.65685 10 10 8.65685 10 7L10 2Z" fill="#0F0F0F"></path> <path d="M14 22C14 22.5523 14.4477 23 15 23C15.5523 23 16 22.5523 16 22V17C16 16.4477 16.4477 16 17 16H22C22.5523 16 23 15.5523 23 15C23 14.4477 22.5523 14 22 14H17C15.3431 14 14 15.3431 14 17V22Z" fill="#0F0F0F"></path> <path d="M14 7C14 8.65686 15.3431 10 17 10L22 10C22.5523 10 23 9.55228 23 9C23 8.44772 22.5523 8 22 8L17 8C16.4477 8 16 7.55229 16 7L16 2C16 1.44772 15.5523 1 15 1C14.4477 1 14 1.44772 14 2L14 7Z" fill="#0F0F0F"></path> */}
            <path d="M20,15 C20.5522847,15 21,15.4477153 21,16 C21,16.5522847 20.5522847,17 20,17 L17,17 L17,20 C17,20.5522847 16.5522847,21 16,21 C15.4477153,21 15,20.5522847 15,20 L15,16 C15,15.4477153 15.4477153,15 16,15 L20,15 Z M4,15 L8,15 C8.51283584,15 8.93550716,15.3860402 8.99327227,15.8833789 L9,16 L9,20 C9,20.5522847 8.55228475,21 8,21 C7.48716416,21 7.06449284,20.6139598 7.00672773,20.1166211 L7,20 L7,17 L4,17 C3.44771525,17 3,16.5522847 3,16 C3,15.4871642 3.38604019,15.0644928 3.88337887,15.0067277 L4,15 L8,15 L4,15 Z M16,3 C16.5128358,3 16.9355072,3.38604019 16.9932723,3.88337887 L17,4 L17,7 L20,7 C20.5522847,7 21,7.44771525 21,8 C21,8.51283584 20.6139598,8.93550716 20.1166211,8.99327227 L20,9 L16,9 C15.4871642,9 15.0644928,8.61395981 15.0067277,8.11662113 L15,8 L15,4 C15,3.44771525 15.4477153,3 16,3 Z M8,3 C8.55228475,3 9,3.44771525 9,4 L9,8 C9,8.55228475 8.55228475,9 8,9 L4,9 C3.44771525,9 3,8.55228475 3,8 C3,7.44771525 3.44771525,7 4,7 L7,7 L7,4 C7,3.44771525 7.44771525,3 8,3 Z">
                {' '}
            </path>
        </svg>
    );
}

export function GridIcon(props) {
    return (
        <svg
            className="icon-grid"
            width="45"
            height="40"
            viewBox="0 0 24 24"
            {...props}
        >
            <path d="M7 3V21"></path>
            <path d="M17 3V21"></path>
            <path d="M21 17L3 17"></path>
            <path d="M21 7L3 7"></path>
        </svg>
    );
}

export function KeyIcon(props) {
    return (
        <svg
            className={`icon-key ${props.isDark ? 'dark' : 'light'} ${props.isPK && 'pk'
                } ${props.isFK && 'fk'}`}
            // viewBox="0 0.75 24 24"
            // width="27px"
            // height="27px"

            viewBox="-1 -0.5 24 24"
            width="27.5px"
            height="27.5px"


        // transform={`${props.scale ? `scale(${props.scale})` : '' })`}
        >
            <path d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path>
        </svg>
    );
}

export function KeyIconSmall(props) {
    return (
        <svg
            className={`icon-key small ${props.isDark ? 'dark' : 'light'} ${props.isPK && 'pk'
                } ${props.isFK && 'fk'}`}
            viewBox="0 0 24 24"
            width="19"
            height="19"
        // transform={`${props.scale ? `scale(${props.scale})` : '' })`}
        >
            <path d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path>
        </svg>
    );
}

export function ModeDarkIcon(props) {
    return (
        <svg
            className="icon-mode-dark"
            width="26"
            height="26"
            viewBox="0 0 256 256"
            {...props}
        >
            <g>
                <path d="M224.30762,150.29346a8.00288,8.00288,0,0,0-10.01416-5.28955A84.03122,84.03122,0,0,1,111.01514,41.6377a8.00207,8.00207,0,0,0-9.96582-9.96192,100.01386,100.01386,0,1,0,123.29,123.2207A8.0018,8.0018,0,0,0,224.30762,150.29346ZM128,212A84.0154,84.0154,0,0,1,92.75391,51.72705a100.00586,100.00586,0,0,0,111.519,111.519A84.30691,84.30691,0,0,1,128,212Z"></path>
            </g>
        </svg>
    );
}

export function ModeLightIcon(props) {
    return (
        // <svg width="24" height="30" viewBox="0 0 24 24" style={{ paddingTop: '3px', marginLeft: '0px' }} {...props}>
        <svg className='icon-mode-light' width="21px" height="23px" viewBox="0 0 24 24" {...props}>
            <g>
                <path
                    className="icon-mode-light-path"
                    d="M11 1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V3C13 3.55228 12.5523 4 12 4C11.4477 4 11 3.55228 11 3V1Z"
                ></path>
                <path
                    className="icon-mode-light-path"
                    d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12ZM8.06167 12C8.06167 14.1751 9.82492 15.9383 12 15.9383C14.1751 15.9383 15.9383 14.1751 15.9383 12C15.9383 9.82492 14.1751 8.06167 12 8.06167C9.82492 8.06167 8.06167 9.82492 8.06167 12Z"
                ></path>
                <path
                    className="icon-mode-light-path"
                    d="M20.4853 3.51472C20.0947 3.12419 19.4616 3.12419 19.0711 3.51472L17.6568 4.92893C17.2663 5.31946 17.2663 5.95262 17.6568 6.34315C18.0474 6.73367 18.6805 6.73367 19.0711 6.34315L20.4853 4.92893C20.8758 4.53841 20.8758 3.90524 20.4853 3.51472Z"
                ></path>
                <path
                    className="icon-mode-light-path"
                    d="M1 13C0.447715 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11H3C3.55228 11 4 11.4477 4 12C4 12.5523 3.55228 13 3 13H1Z"
                ></path>
                <path
                    className="icon-mode-light-path"
                    d="M3.51472 3.51472C3.1242 3.90524 3.1242 4.53841 3.51472 4.92893L4.92894 6.34315C5.31946 6.73367 5.95263 6.73367 6.34315 6.34315C6.73368 5.95262 6.73368 5.31946 6.34315 4.92893L4.92894 3.51472C4.53841 3.12419 3.90525 3.12419 3.51472 3.51472Z"
                ></path>
                <path
                    className="icon-mode-light-path"
                    d="M11 21C11 20.4477 11.4477 20 12 20C12.5523 20 13 20.4477 13 21V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V21Z"
                ></path>
                <path
                    className="icon-mode-light-path"
                    d="M6.34315 17.6569C5.95263 17.2663 5.31946 17.2663 4.92894 17.6569L3.51473 19.0711C3.1242 19.4616 3.1242 20.0948 3.51473 20.4853C3.90525 20.8758 4.53842 20.8758 4.92894 20.4853L6.34315 19.0711C6.73368 18.6805 6.73368 18.0474 6.34315 17.6569Z"
                ></path>
                <path
                    className="icon-mode-light-path"
                    d="M21 13C20.4477 13 20 12.5523 20 12C20 11.4477 20.4477 11 21 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H21Z"
                ></path>
                <path
                    className="icon-mode-light-path"
                    d="M17.6568 17.6569C17.2663 18.0474 17.2663 18.6805 17.6568 19.0711L19.0711 20.4853C19.4616 20.8758 20.0947 20.8758 20.4853 20.4853C20.8758 20.0948 20.8758 19.4616 20.4853 19.0711L19.0711 17.6569C18.6805 17.2663 18.0474 17.2663 17.6568 17.6569Z"
                ></path>
            </g>
        </svg>
    );
}

export function PointerIcon(props) {
    return (
        // <svg className="icon-pointer" width="28" height="54" viewBox="0 0 24 24" {...props}>
        <svg
            className="icon-pointer"
            width="28"
            height="44"
            viewBox="0 0 24 24"
            {...props}
        >
            <g>
                <path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path>
                <path d="M13 13l6 6"></path>
            </g>
        </svg>
    );
}

export function ResizeToFitIcon(props) {
    return (
        <svg viewBox="0 0 20 20" width="28" height="32" {...props}>
            <path
                className="icon-resizetofit-path"
                d="M18 4.25C18 3.83579 17.6642 3.5 17.25 3.5C16.8358 3.5 16.5 3.83579 16.5 4.25L16.5 15.25C16.5 15.6642 16.8358 16 17.25 16C17.6642 16 18 15.6642 18 15.25V4.25ZM3.5 4.25C3.5 3.83579 3.16421 3.5 2.75 3.5C2.33579 3.5 2 3.83579 2 4.25L2 15.25C2 15.6642 2.33579 16 2.75 16C3.16421 16 3.5 15.6642 3.5 15.25L3.5 4.25ZM5.21967 10.2803L7.21967 12.2803C7.51256 12.5732 7.98744 12.5732 8.28033 12.2803C8.57322 11.9874 8.57322 11.5126 8.28033 11.2197L7.56066 10.5L12.4393 10.5L11.7197 11.2197C11.4268 11.5126 11.4268 11.9874 11.7197 12.2803C12.0126 12.5732 12.4874 12.5732 12.7803 12.2803L14.7803 10.2803C15.0732 9.98744 15.0732 9.51256 14.7803 9.21967L12.7803 7.21967C12.4874 6.92678 12.0126 6.92678 11.7197 7.21967C11.4268 7.51256 11.4268 7.98744 11.7197 8.28033L12.4393 9L7.56066 9L8.28033 8.28033C8.57322 7.98744 8.57322 7.51256 8.28033 7.21967C7.98744 6.92678 7.51256 6.92678 7.21967 7.21967L5.21967 9.21967C4.92678 9.51256 4.92678 9.98744 5.21967 10.2803Z"
            ></path>
        </svg>
    );
}

export function SliderIcon(props) {
    return (
        <svg viewBox="0 0 6 20" {...props}>
            <g>
                <rect x="0.5" y="0.5" width="1" height="19" />
                <path d="M1,1v18V1 M2,0H0v20h2V0L2,0z" />
            </g>
            <g>
                <rect x="4.5" y="0.5" width="1" height="19" />
                <path d="M5,1v18V1 M6,0H4v20h2V0L6,0z" />
            </g>
        </svg>
    );
}

export function TableDarkIcon(props) {
    let headBackground = '#333b44';
    let cellBackground = '#444e5a';
    let lineBackground = '#262c31';

    // headBackground = '#79899a';
    // cellBackground = '#8794a4';
    // lineBackground = '#708290';

    // if (props.isGreen) {
    //     headBackground = '#10533c';
    //     cellBackground = '#14694c';
    // }

    // if (props.isRed) {
    //     headBackground = '#661320';
    //     cellBackground = '#821829';
    // }

    // if (props.isNewDark) {
    // headBackground = '#708290';
    // cellBackground = '#b4b4b4';
    // lineBackground = '#262c31';

    headBackground = '#83929f';
    cellBackground = '#cfd5da';
    lineBackground = '#1c2125';

    // }

    return (
        <svg
            viewBox="0 0 64 64"
            className={`${props.class ? props.class : ''}`}
            style={{ width: '28px', display: 'flex' }}
        >
            <g stroke="#1c2125" strokeWidth="2" fill="none" fillRule="evenodd">
                <g transform="translate(-180.000000, -400.000000)"></g>
                <g transform="translate(-175.000000, -395.000000)">
                    <g transform="translate(182.000000, 404.000000)">
                        <path
                            fill={headBackground}
                            d="M45,0 L3,0 C1.343,0 0,1.344 0,3 L0,12 L48,12 L48,3 C48,1.344 46.657,0 45,0"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M0,45 C0,46.656 1.343,48 3,48 L12,48 L12,36 L0,36 L0,45 Z"
                        ></path>
                        {/* <polygon fill={cellBackground} points="0 36 12 36 12 24 0 24"></polygon>
                        <polygon fill={cellBackground} points="12 48 24 48 24 36 12 36"></polygon>
                        <polygon fill={cellBackground} points="24 48 36 48 36 36 24 36"></polygon>
                        <polygon fill={cellBackground} points="12 36 24 36 24 24 12 24"></polygon>
                        <polygon fill={cellBackground} points="24 36 36 36 36 24 24 24"></polygon>
                        <polygon fill={cellBackground} points="36 36 48 36 48 24 36 24"></polygon>
                        <polygon fill={cellBackground} points="0 24 12 24 12 12 0 12"></polygon>
                        <polygon fill={cellBackground} points="12 24 24 24 24 12 12 12"></polygon>
                        <polygon fill={cellBackground} points="24 24 36 24 36 12 24 12"></polygon>
                        <polygon fill={cellBackground} points="36 24 48 24 48 12 36 12"></polygon> */}
                        <path
                            fill={cellBackground}
                            d="M0,36 L12,36 L12,24 L0,24 Z"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M12,48 L24,48 L24,36 L12,36 Z"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M24,48 L36,48 L36,36 L24,36 Z"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M12,36 L24,36 L24,24 L12,24 Z"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M24,36 L36,36 L36,24 L24,24 Z"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M36,36 L48,36 L48,24 L36,24 Z"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M0,24 L12,24 L12,12 L0,12 Z"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M12,24 L24,24 L24,12 L12,12 Z"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M24,24 L36,24 L36,12 L24,12 Z"
                        ></path>
                        <path
                            fill={cellBackground}
                            d="M36,24 L48,24 L48,12 L36,12 Z"
                        ></path>

                        <path
                            fill={cellBackground}
                            d="M36,36 L36,48 L45,48 C46.657,48 48,46.656 48,45 L48,36 L36,36 Z"
                        ></path>
                        <path
                            stroke={lineBackground}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M45,0 L3,0 C1.343,0 0,1.343 0,3 L0,45 C0,46.657 1.343,48 3,48 L45,48 C46.657,48 48,46.657 48,45 L48,3 C48,1.343 46.657,0 45,0 Z"
                        ></path>
                        <path
                            stroke={lineBackground}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M0,12 L48,12"
                        ></path>
                        <path
                            stroke={lineBackground}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M0,24 L48,24"
                        ></path>
                        <path
                            stroke={lineBackground}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M0,36 L48,36"
                        ></path>
                        <path
                            stroke={lineBackground}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M24,12 L24,48"
                        ></path>
                        <path
                            stroke={lineBackground}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M36,12 L36,48"
                        ></path>
                        <path
                            stroke={lineBackground}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12,12 L12,48"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
export function TableDarkIconNew() {
    let headBackground = '#333b44';
    let cellBackground = '#444e5a';
    let lineBackground = '#262c31';

    // headBackground = '#79899a';
    // cellBackground = '#8794a4';
    // lineBackground = '#708290';

    // if (props.isGreen) {
    //     headBackground = '#10533c';
    //     cellBackground = '#14694c';
    // }

    // if (props.isRed) {
    //     headBackground = '#661320';
    //     cellBackground = '#821829';
    // }

    // if (props.isNewDark) {
    // headBackground = '#708290';
    // cellBackground = '#b4b4b4';
    // lineBackground = '#262c31';

    headBackground = '#83929f';
    cellBackground = '#cfd5da';
    lineBackground = '#1c2125';

    // }

    return (
        <svg viewBox="-1 -1 50 50" width="17px">
            <g stroke="#1c2125" strokeWidth="2" fill="none" fillRule="evenodd">
                <path
                    fill={headBackground}
                    d="M45,0 L3,0 C1.343,0 0,1.344 0,3 L0,12 L48,12 L48,3 C48,1.344 46.657,0 45,0"
                ></path>
                <path
                    fill={cellBackground}
                    d="M0,45 C0,46.656 1.343,48 3,48 L12,48 L12,36 L0,36 L0,45 M0,36 L12,36 L12,24 L0,24 M12,48 L24,48 L24,36 L12,36 M24,48 L36,48 L36,36 L24,36 M12,36 L24,36 L24,24 L12,24 M24,36 L36,36 L36,24 L24,24 M36,36 L48,36 L48,24 L36,24 M0,24 L12,24 L12,12 L0,12 M12,24 L24,24 L24,12 L12,12 M24,24 L36,24 L36,12 L24,12 M36,24 L48,24 L48,12 L36,12 M36,36 L36,48 L45,48 C46.657,48 48,46.656 48,45 L48,36 L36,36 Z"
                ></path>
                <path
                    stroke={lineBackground}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M45,0 L3,0 C1.343,0 0,1.343 0,3 L0,45 C0,46.657 1.343,48 3,48 L45,48 C46.657,48 48,46.657 48,45 L48,3 C48,1.343 46.657,0 45,0 M0,12 L48,12M0,24 L48,24 M0,36 L48,36 M24,12 L24,48 M36,12 L36,48 M12,12 L12,48"
                ></path>
            </g>
        </svg>
    );
}

export function TableLightIcon(props) {
    return (
        <svg
            viewBox="0 0 64 64"
            className={`${props.class ? props.class : ''}`}
            style={{ width: '28px', display: 'flex' }}
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-180.000000, -400.000000)"></g>
                <g transform="translate(-175.000000, -395.000000)">
                    <g transform="translate(182.000000, 404.000000)">
                        <path
                            fill="#FFFFFF"
                            d="M0,45 C0,46.656 1.343,48 3,48 L12,48 L12,36 L0,36 L0,45 Z"
                        ></path>
                        <polygon
                            fill="#FFFFFF"
                            points="0 36 12 36 12 24 0 24"
                        ></polygon>
                        <polygon
                            fill="#FFFFFF"
                            points="12 48 24 48 24 36 12 36"
                        ></polygon>
                        <polygon
                            fill="#FFFFFF"
                            points="24 48 36 48 36 36 24 36"
                        ></polygon>
                        <polygon
                            fill="#FFFFFF"
                            points="12 36 24 36 24 24 12 24"
                        ></polygon>
                        <polygon
                            fill="#FFFFFF"
                            points="24 36 36 36 36 24 24 24"
                        ></polygon>
                        <polygon
                            fill="#FFFFFF"
                            points="36 36 48 36 48 24 36 24"
                        ></polygon>
                        <polygon
                            fill="#FFFFFF"
                            points="0 24 12 24 12 12 0 12"
                        ></polygon>
                        <polygon
                            fill="#FFFFFF"
                            points="12 24 24 24 24 12 12 12"
                        ></polygon>
                        <polygon
                            fill="#FFFFFF"
                            points="24 24 36 24 36 12 24 12"
                        ></polygon>
                        <polygon
                            fill="#FFFFFF"
                            points="36 24 48 24 48 12 36 12"
                        ></polygon>
                        <path
                            fill="#84addb"
                            d="M45,0 L3,0 C1.343,0 0,1.344 0,3 L0,12 L48,12 L48,3 C48,1.344 46.657,0 45,0"
                        ></path>
                        <path
                            fill="#FFFFFF"
                            d="M36,36 L36,48 L45,48 C46.657,48 48,46.656 48,45 L48,36 L36,36 Z"
                        ></path>
                        <path
                            stroke="#5a6d9b"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M45,0 L3,0 C1.343,0 0,1.343 0,3 L0,45 C0,46.657 1.343,48 3,48 L45,48 C46.657,48 48,46.657 48,45 L48,3 C48,1.343 46.657,0 45,0 Z"
                        ></path>
                        <path
                            d="M0,12 L48,12"
                            stroke="#5a6d9b"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M0,24 L48,24"
                            stroke="#5a6d9b"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M0,36 L48,36"
                            stroke="#5a6d9b"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M24,12 L24,48"
                            stroke="#5a6d9b"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M36,12 L36,48"
                            stroke="#5a6d9b"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M12,12 L12,48"
                            stroke="#5a6d9b"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export function PlusIcon(props) {
    return (
        <svg className="icon-plus" width="17" height="19" viewBox="0 0 20 20" {...props}>
            <g>
                <path
                    className="icon-plus-path"
                    fillRule="evenodd"
                    d="M9 17a1 1 0 102 0v-6h6a1 1 0 100-2h-6V3a1 1 0 10-2 0v6H3a1 1 0 000 2h6v6z"
                ></path>
            </g>
        </svg>
    );
}

export function MinusIcon(props) {
    return (
        <svg className="icon-minus" width="18" height="19" viewBox="0 0 20 20" {...props}>
            <g>
                <path
                    className="icon-minus-path"
                    fillRule="evenodd"
                    d="M18 10a1 1 0 01-1 1H3a1 1 0 110-2h14a1 1 0 011 1z"
                ></path>
            </g>
        </svg>
    );
}

export function PencilIcon(props) {
    return (
        <svg
            className="icon-pencil"
            width="32px"
            height="32px"
            viewBox="0 0 512 512"
            {...props}
        >
            <g>
                <polygon
                    fill="none"
                    points="60.299,357.12 34.768,430.851 81.149,477.232 154.88,451.7 452.669,153.911 358.089,59.33 "
                ></polygon>
                <path d="M400.931,16.487L358.089,59.33l94.581,94.581l42.842-42.842c8.404-8.404,8.404-22.03,0-30.434 l-64.147-64.147C422.961,8.084,409.335,8.084,400.931,16.487z"></path>
                <polygon points="10.199,501.8 81.149,477.232 34.768,430.851 "></polygon>
                <g>
                    <path d="M53.087,349.907c-1.091,1.091-1.921,2.416-2.425,3.875l-50.1,144.68 c-1.278,3.691-0.336,7.788,2.425,10.55C4.932,510.957,7.539,512,10.201,512c1.118,0,2.245-0.184,3.336-0.562l144.681-50.1 c1.459-0.505,2.783-1.335,3.875-2.425l340.631-340.631c12.367-12.368,12.367-32.491,0-44.859L438.577,9.275 c-12.367-12.367-32.49-12.367-44.857,0l0,0L53.087,349.907z M65.104,374.415l72.481,72.481l-53.739,18.609l-37.351-37.351 L65.104,374.415z M26.711,485.288l12.364-35.705l23.342,23.342L26.711,485.288z M155.848,436.308l-50.783-50.783l125.381-125.381 c3.983-3.983,3.983-10.441,0-14.425c-3.983-3.982-10.441-3.982-14.425,0L90.641,371.101l-14.948-14.948L358.089,73.755 l40.078,40.078l40.078,40.078L155.848,436.308z M488.299,103.856l-35.63,35.63L372.513,59.33l35.63-35.631 c4.414-4.414,11.597-4.414,16.01,0l64.147,64.147C492.714,92.259,492.714,99.443,488.299,103.856z"></path>
                    <path d="M254.269,207.472l-14.279,14.279c-3.983,3.983-3.983,10.441,0,14.425 c1.992,1.991,4.602,2.987,7.212,2.987c2.61,0,5.221-0.997,7.212-2.987l14.279-14.279c3.983-3.983,3.983-10.441,0-14.425 C264.711,203.49,258.253,203.49,254.269,207.472z"></path>
                </g>
            </g>
        </svg>
    );
}

export function KeyNewIcon(props) {
    return (
        <svg
            className="icon-key"
            width="64px"
            height="64px"
            viewBox="0 0 24.00 24.00"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M12.3212 10.6852L4 19L6 21M7 16L9 18M20 7.5C20 9.98528 17.9853 12 15.5 12C13.0147 12 11 9.98528 11 7.5C11 5.01472 13.0147 3 15.5 3C17.9853 3 20 5.01472 20 7.5Z"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function NoteSmallIcon() {
    return (
        <svg
            className="icon-note"
            width="24px"
            height="24px"
            viewBox="-1.5 -0.5 33 25"
            strokeWidth="1.5"
            style={{
                transform: 'rotate(180deg)',
                marginLeft: '2px',
                marginTop: '2px',
            }}
        >
            <g>
                <path d="M 11.5 12 M 27.5 6 V 19.5858 a 1.4903 1.4903 0 0 1 -0.4394 1.0607 l -6.4141 6.4142 A 1.4902 1.4902 0 0 1 19.5858 27.5 H 6 a 1.5017 1.5017 0 0 1 -1.5 -1.5 V 1 A 1.5017 1.5017 0 0 1 6 -0.5 H 26 A 1.5017 1.5017 0 0 1 27.5 1 Z M 6 26.5 H 19.5 V 20 a 0.5 0.5 0 0 1 0.5 -0.5 h 6.5 V 1 a 0.5006 0.5006 0 0 0 -0.5 -0.5 H 6 a 0.5006 0.5006 0 0 0 -0.5 0.5 V 26 A 0.5006 0.5006 0 0 0 6 26.5 Z m 19.7939 -6.001 H 20.5 v 5.2938 Z"></path>
            </g>
        </svg>
    );
}

export function NoteIcon() {
    return (
        <svg
            className="icon-note"
            width="28px"
            height="30px"
            viewBox="-1.5 -0.5 33 25"
            strokeWidth="1.1"
            style={{
                transform: 'rotate(180deg)',
                marginLeft: '2px',
                marginTop: '2px',
            }}
        >
            <g>
                <path d="M 11.5 12 M 27.5 6 V 19.5858 a 1.4903 1.4903 0 0 1 -0.4394 1.0607 l -6.4141 6.4142 A 1.4902 1.4902 0 0 1 19.5858 27.5 H 6 a 1.5017 1.5017 0 0 1 -1.5 -1.5 V 1 A 1.5017 1.5017 0 0 1 6 -0.5 H 26 A 1.5017 1.5017 0 0 1 27.5 1 Z M 6 26.5 H 19.5 V 20 a 0.5 0.5 0 0 1 0.5 -0.5 h 6.5 V 1 a 0.5006 0.5006 0 0 0 -0.5 -0.5 H 6 a 0.5006 0.5006 0 0 0 -0.5 0.5 V 26 A 0.5006 0.5006 0 0 0 6 26.5 Z m 19.7939 -6.001 H 20.5 v 5.2938 Z"></path>
            </g>
        </svg>
        // <path d="M 11.5 12 M 27.5 6 V 19.5858 a 1.4903 1.4903 0 0 1 -0.4394 1.0607 l -6.4141 6.4142 A 1.4902 1.4902 0 0 1 19.5858 27.5 H 6 a 1.5017 1.5017 0 0 1 -1.5 -1.5 V 0 A 1.5017 1.5017 0 0 1 6 -1.5 H 26 A 1.5017 1.5017 0 0 1 27.5 0 Z M 6 26.5 H 19.5 V 20 a 0.5 0.5 0 0 1 0.5 -0.5 h 6.5 V 0 a 0.5006 0.5006 0 0 0 -0.5 -0.5 H 6 a 0.5006 0.5006 0 0 0 -0.5 0.5 V 26 A 0.5006 0.5006 0 0 0 6 26.5 Z m 19.7939 -6.001 H 20.5 v 5.2938 Z"></path></g></svg>

        // <svg className="icon-note" width="32px" height="32px" viewBox="0 0 32 32" id="Flat" xmlns="http://www.w3.org/2000/svg" strokeWidth="1"
        //     style={{ marginLeft: '0px', marginTop: '3px' }}>
        //     <g strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC" strokeWidth="0.192"></g>
        //     <g>
        //         <path d="M11.5,12a0.5,0.5,0,0,1,0.5-0.5h8a0.5,0.5,0,0,1,0,1h-8A0.5,0.5,0,0,1,11.5,12Zm0.5,4.5h8a0.5,0.5,0,0,0,0-1h-8a0.5,0.5,0,0,0,0,1Zm4,3h-4a0.5,0.5,0,0,0,0,1h4a0.5,0.5,0,0,0,0-1ZM27.5,6V19.58582a1.49028,1.49028,0,0,1-0.43939,1.06067l-6.41412,6.41418A1.49022,1.49022,0,0,1,19.58582,27.5H6a1.50172,1.50172,0,0,1-1.5-1.5V6A1.50172,1.50172,0,0,1,6,4.5H26A1.50172,1.50172,0,0,1,27.5,6ZM6,26.5H19.5V20a0.5,0.5,0,0,1,0.5-0.5h6.5V6a0.50057,0.50057,0,0,0-0.5-0.5H6a0.50057,0.50057,0,0,0-0.5,0.5V26A0.50057,0.50057,0,0,0,6,26.5Zm19.79388-6.00098H20.5v5.29382Z"></path>
        //     </g>
        // </svg>

        // <svg fill="#000000" width="38px" height="38px" viewBox="0 0 38 38" id="Flat" xmlns="http://www.w3.org/2000/svg" stroke="#000000" strokeWidth="1">
        //     <g>
        //         <path d="M11.789,12a0.593,0.593,0,0,1,0.593-0.593h9.614a0.593,0.593,0,0,1,0,1.186H12.382A0.593,0.593,0,0,1,11.789,12Zm0.593,4.952h9.614a0.593,0.593,0,0,0,0-1.186H12.382a0.593,0.593,0,0,0,0,1.186Zm4.808,3.559H12.382a0.593,0.593,0,0,0,0,1.186h4.808a0.593,0.593,0,0,0,0-1.186ZM31.6,8.571V27.841a1.778,1.778,0,0,1-0.593,1.292l-7.813,7.813a1.778,1.778,0,0,1-1.292,0.593H8.571a1.789,1.789,0,0,1-1.786-1.786V8.571a1.789,1.789,0,0,1,1.786-1.786H29.814A1.789,1.789,0,0,1,31.6,8.571ZM8.571,30.229H21.771V20.522a0.593,0.593,0,0,1,0.593-0.593h9.614V8.571a0.593,0.593,0,0,0-0.593-0.593H8.571a0.593,0.593,0,0,0-0.593,0.593V29.814A0.593,0.593,0,0,0,8.571,30.229Zm21.883-7.254H21.771v5.808Z"></path>
        //     </g>
        // </svg>

        // <svg fill="#000000" width="256px" height="256px" viewBox="0 0 256.00 256.00" id="Flat" xmlns="http://www.w3.org/2000/svg" stroke="#000000" strokeWidth="0.00256"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC" strokeWidth="1.536"></g><g> <path d="M92,96a4.0002,4.0002,0,0,1,4-4h64a4,4,0,0,1,0,8H96A4.0002,4.0002,0,0,1,92,96Zm4,36h64a4,4,0,0,0,0-8H96a4,4,0,0,0,0,8Zm32,24H96a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM220,48V156.68652a11.92221,11.92221,0,0,1-3.51514,8.48536l-51.313,51.31347A11.92174,11.92174,0,0,1,156.68652,220H48a12.01375,12.01375,0,0,1-12-12V48A12.01375,12.01375,0,0,1,48,36H208A12.01375,12.01375,0,0,1,220,48ZM48,212H156V159.99219a3.99988,3.99988,0,0,1,4-4h52V48a4.00458,4.00458,0,0,0-4-4H48a4.00458,4.00458,0,0,0-4,4V208A4.00458,4.00458,0,0,0,48,212Zm158.35107-48.00781H164v42.35058Z"></path> </g></svg>
        // <svg fill="#000000" width="36px" height="36px" viewBox="0 0 128 128" id="Flat"
        //     xmlns="http://www.w3.org/2000/svg">
        //     <g>
        //     <path stroke="#000000" strokeWidth="1" d="M46,48a2,2,0,0,1,2-2h32a2,2,0,0,1,0,4H48A2,2,0,0,1,46,48Zm2,18h32a2,2,0,0,0,0-4H48a2,2,0,0,0,0,4Zm16,12H48a2,2,0,0,0,0,4h16a2,2,0,0,0,0-4ZM110,24V78.34326a5.9611,5.9611,0,0,1-1.75757,4.24268l-25.6565,25.65673A5.96087,5.96087,0,0,1,78.34326,110H24a6.00688,6.00688,0,0,1-6-6V24a6.00688,6.00688,0,0,1,6-6H104A6.00688,6.00688,0,0,1,110,24ZM24,106H78V79.9961a1.99994,1.99994,0,0,1,2-2h26V24a2.00229,2.00229,0,0,0-2-2H24a2.00229,2.00229,0,0,0-2,2V104A2.00229,2.00229,0,0,0,24,106Zm79.17554-24.00391H82v21.17529Z"></path>
        //     </g>
        // </svg>
    );
}

export function TableIconNew() {
    return (
        <svg
            className="icon-table-new"
            width="32px"
            height="32px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
        >
            <g strokeWidth="0"></g>
            <g
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g>
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.25"
                    d="M3 8V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2M3 8v6m0-6h6m12 0v6m0-6H9m12 6v4a2 2 0 0 1-2 2H9m12-6H9m-6 0v4a2 2 0 0 0 2 2h4m-6-6h6m0-6v6m0 0v6m6-12v12"
                ></path>
            </g>
        </svg>

        // <svg width="36px" height="36px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g> <path d="M4 10V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V10M4 10V15M4 10H9M20 10V15M20 10H15M4 15V18C4 19.1046 4.89543 20 6 20H9M4 15H9M20 15V18C20 19.1046 19.1046 20 18 20H15M20 15H15M9 15H15M9 15V10M9 15V20M15 15V10M15 15V20M9 10H15M9 20H15M10 7H14" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
        // <svg width="32px" height="32px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g ><path stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M3 8V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2M3 8v6m0-6h6m12 0v6m0-6H9m12 6v4a2 2 0 0 1-2 2H9m12-6H9m-6 0v4a2 2 0 0 0 2 2h4m-6-6h6m0-6v6m0 0v6m6-12v12"></path><path fill="#000000" d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2H3V6z"></path></g></svg>
    );
}

export function TableIconNewSmall() {
    return (
        <svg
            className="icon-table-new-small"
            width="19px"
            height="19px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
        >
            <g>
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.25"
                    d="M3 8V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2M3 8v6m0-6h6m12 0v6m0-6H9m12 6v4a2 2 0 0 1-2 2H9m12-6H9m-6 0v4a2 2 0 0 0 2 2h4m-6-6h6m0-6v6m0 0v6m6-12v12"
                ></path>
            </g>
        </svg>

        // <svg width="36px" height="36px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g> <path d="M4 10V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V10M4 10V15M4 10H9M20 10V15M20 10H15M4 15V18C4 19.1046 4.89543 20 6 20H9M4 15H9M20 15V18C20 19.1046 19.1046 20 18 20H15M20 15H15M9 15H15M9 15V10M9 15V20M15 15V10M15 15V20M9 10H15M9 20H15M10 7H14" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
        // <svg width="32px" height="32px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g><path stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M3 8V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2M3 8v6m0-6h6m12 0v6m0-6H9m12 6v4a2 2 0 0 1-2 2H9m12-6H9m-6 0v4a2 2 0 0 0 2 2h4m-6-6h6m0-6v6m0 0v6m6-12v12"></path><path fill="#000000" d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2H3V6z"></path></g></svg>
    );
}

export function TableIconNewControls() {
    return (
        <svg
            className="icon-table-new-controls-new"
            fill="#000000"
            width="30px"
            height="31px"
            viewBox="0 0 32 32"
            id="icon"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* <g><path d="M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"></path></g> */}
            <g>
                <path d="M 27 3 H 5 A 2 2 0 0 0 3 5 V 27 a 2 2 0 0 0 2 2 H 27 a 2 2 0 0 0 2 -2 V 5 A 2 2 0 0 0 27 3 Z m 0 4 V 13 H 5 V 7 Z M 17 15 H 27 v 5 H 17 Z m -2 5 H 5 V 15 H 15 Z M 5 22 H 15 v 5 H 5 Z m 12 5 V 22 H 27 v 5 Z"></path>
            </g>
        </svg>

        // <svg className="icon-table-new" fill="#ffffff" width="28px" height="28px" viewBox="0 0 1920 1920">
        //     <g> <path d="M1740 0c99.24 0 180 80.76 180 180v1560c0 99.24-80.76 180-180 180H180c-99.24 0-180-80.76-180-180V180C0 80.76 80.76 0 180 0h1560Zm-420 1200h480V720h-480v480Zm480 540v-420h-480v480h420c33 0 60-27 60-60ZM720 1200h480V720H720v480Zm0 600h480v-480H720v480Zm-600-600h480V720H120v480Zm480 600v-480H120v420c0 33 27 60 60 60h420Z" fillRule="evenodd"></path> </g>
        // </svg>
    );
}

export function TableIconNewControlsSmall() {
    return (
        <svg
            className="icon-table-new-controls-new"
            fill="#000000"
            width="18px"
            height="18px"
            viewBox="0 0 32 32"
            id="icon"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* <g><path d="M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"></path></g> */}
            <g>
                <path d="M 27 3 H 5 A 2 2 0 0 0 3 5 V 27 a 2 2 0 0 0 2 2 H 27 a 2 2 0 0 0 2 -2 V 5 A 2 2 0 0 0 27 3 Z m 0 4 V 13 H 5 V 7 Z M 17 15 H 27 v 5 H 17 Z m -2 5 H 5 V 15 H 15 Z M 5 22 H 15 v 5 H 5 Z m 12 5 V 22 H 27 v 5 Z"></path>
            </g>
        </svg>

        // <svg className="icon-table-new" fill="#ffffff" width="28px" height="28px" viewBox="0 0 1920 1920">
        //     <g> <path d="M1740 0c99.24 0 180 80.76 180 180v1560c0 99.24-80.76 180-180 180H180c-99.24 0-180-80.76-180-180V180C0 80.76 80.76 0 180 0h1560Zm-420 1200h480V720h-480v480Zm480 540v-420h-480v480h420c33 0 60-27 60-60ZM720 1200h480V720H720v480Zm0 600h480v-480H720v480Zm-600-600h480V720H120v480Zm480 600v-480H120v420c0 33 27 60 60 60h420Z" fillRule="evenodd"></path> </g>
        // </svg>
    );
}

export function CommentIcon() {
    return (
        <svg
            className="icon-comment"
            width="24px"
            height="25px"
            viewBox="0 0 24 24"
        >
            <g>
                <path d="M20,20h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v12c0,1.1,0.9,2,2,2h4 c0.6,0,1,0.4,1,1s-0.4,1-1,1H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v12C24,18.2,22.2,20,20,20z"></path>
            </g>
            <g>
                <path d="M12,24c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.3,3.3l3.3-3.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4 l-4,4C12.5,23.9,12.3,24,12,24z"></path>
            </g>
            <g>
                {' '}
                <path d="M18,7H6C5.4,7,5,6.6,5,6s0.4-1,1-1h12c0.6,0,1,0.4,1,1S18.6,7,18,7z"></path>{' '}
            </g>
            <g>
                {' '}
                <path d="M13,11H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h7c0.6,0,1,0.4,1,1S13.6,11,13,11z"></path>{' '}
            </g>
            <g>
                {' '}
                <path d="M16,15H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h10c0.6,0,1,0.4,1,1S16.6,15,16,15z"></path>{' '}
            </g>
        </svg>
    );
}

export function PointerIconNew() {
    return (
        <svg
            className="icon-pointer-new"
            height="32px"
            width="30px"
            viewBox="-74.25 -74.25 445.50 445.50"
        >
            <g>
                {' '}
                <g>
                    {' '}
                    <path d="M247.094,297c-2.831,0-5.549-1.125-7.551-3.129l-82.835-82.868l-34.905,60.448c-2.046,3.544-5.936,5.61-10.017,5.31 c-4.081-0.296-7.634-2.896-9.148-6.697L0.825,14.632c-1.58-3.965-0.648-8.489,2.369-11.505C6.212,0.108,10.735-0.82,14.7,0.761 l255.317,101.86c3.799,1.515,6.397,5.067,6.693,9.148c0.295,4.079-1.766,7.968-5.308,10.015l-60.435,34.929l82.839,82.878 c4.168,4.169,4.168,10.926,0.001,15.096l-39.162,39.186C252.643,295.873,249.927,297,247.094,297z M154.422,182.934 c2.813,0,5.534,1.112,7.551,3.129l85.121,85.156l24.067-24.082l-85.126-85.162c-2.347-2.348-3.469-5.651-3.036-8.941 c0.433-3.291,2.371-6.191,5.244-7.852l53.427-30.879L29.86,29.801l84.462,211.902l30.853-53.433 c1.66-2.874,4.563-4.813,7.854-5.246C153.494,182.964,153.959,182.934,154.422,182.934z"></path>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function PenIconNew() {
    return (
        // <svg className='icon-pen' width="32px" height="32px" viewBox="0 -0.5 25 25" fill="none"><g strokeLinecap="round" strokeLinejoin="round"></g><g> <path fillRule="evenodd" clipRule="evenodd" d="M17.265 4.16231L19.21 5.74531C19.3978 5.9283 19.5031 6.17982 19.5015 6.44201C19.5 6.70421 19.3919 6.9545 19.202 7.13531L17.724 8.93531L12.694 15.0723C12.6069 15.1749 12.4897 15.2473 12.359 15.2793L9.75102 15.8793C9.40496 15.8936 9.10654 15.6384 9.06702 15.2943L9.18902 12.7213C9.19806 12.5899 9.25006 12.4652 9.33702 12.3663L14.15 6.50131L15.845 4.43331C16.1743 3.98505 16.7938 3.86684 17.265 4.16231Z" stroke="#000000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M5.5 18.2413C5.08579 18.2413 4.75 18.5771 4.75 18.9913C4.75 19.4056 5.08579 19.7413 5.5 19.7413V18.2413ZM19.2 19.7413C19.6142 19.7413 19.95 19.4056 19.95 18.9913C19.95 18.5771 19.6142 18.2413 19.2 18.2413V19.7413ZM14.8455 6.22062C14.6904 5.83652 14.2534 5.65082 13.8693 5.80586C13.4852 5.9609 13.2995 6.39796 13.4545 6.78206L14.8455 6.22062ZM17.8893 9.66991C18.2933 9.57863 18.5468 9.17711 18.4556 8.77308C18.3643 8.36904 17.9628 8.1155 17.5587 8.20678L17.8893 9.66991ZM5.5 19.7413H19.2V18.2413H5.5V19.7413ZM13.4545 6.78206C13.6872 7.35843 14.165 8.18012 14.8765 8.8128C15.6011 9.45718 16.633 9.95371 17.8893 9.66991L17.5587 8.20678C16.916 8.35198 16.3609 8.12551 15.8733 7.69189C15.3725 7.24656 15.0128 6.63526 14.8455 6.22062L13.4545 6.78206Z" fill="#000000"></path> </g></svg>
        <svg
            className="icon-pen-new"
            fill="#ffffff"
            width="28px"
            height="30px"
            viewBox="0 0 36 36"
            version="1.1"
        >
            <g>
                <path d="M33.87,8.32,28,2.42a2.07,2.07,0,0,0-2.92,0L4.27,23.2l-1.9,8.2a2.06,2.06,0,0,0,2,2.5,2.14,2.14,0,0,0,.43,0L13.09,32,33.87,11.24A2.07,2.07,0,0,0,33.87,8.32ZM12.09,30.2,4.32,31.83l1.77-7.62L21.66,8.7l6,6ZM29,13.25l-6-6,3.48-3.46,5.9,6Z"></path>
            </g>
        </svg>
    );
}

export function TableGroupIcon() {
    return (
        <svg
            className="icon-table-group"
            width="32px"
            height="32px"
            viewBox="0 0 24 24"
            fill="none"
        >
            <g>
                {' '}
                <path
                    d="M7 4H4V7"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M4 11V13"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M11 4H13"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M11 20H13"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M20 11V13"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M17 4H20V7"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M7 20H4V17"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M17 20H20V17"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>

        // <svg className='icon-table-group' width="32px" height="32px" viewBox="0 0 24 24" fill="none" >
        //     <g>
        //         <path d="M7 4H4V7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M4 11V13" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M11 4H13" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M11 20H13" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M20 11V13" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M17 4H20V7" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M7 20H4V17" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M17 20H20V17" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
    );
}

export function TableGroupNewIcon() {
    return (
        <svg
            className="icon-table-group-new"
            width="30px"
            height="32px"
            viewBox="0 0 256 256"
            fill="none"
            strokeWidth="10"
            stroke="#ffffff"
        >
            {/* <svg className='icon-table-group-new' width="32px" height="32px" viewBox="0 0 256 256" fill="none" strokeWidth="8.959999999999999" stroke="#ffffff"> */}
            <g>
                {' '}
                <path d="M148,40a4.0002,4.0002,0,0,1-4,4H112a4,4,0,0,1,0-8h32A4.0002,4.0002,0,0,1,148,40Zm-4,172H112a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM208,36H184a4,4,0,0,0,0,8h24a4.00458,4.00458,0,0,1,4,4V71.99951a4,4,0,0,0,8,0V48A12.01375,12.01375,0,0,0,208,36Zm8,71.99951a4.0002,4.0002,0,0,0-4,4v32a4,4,0,0,0,8,0v-32A4.0002,4.0002,0,0,0,216,107.99951Zm0,72a4.0002,4.0002,0,0,0-4,4V208a4.00458,4.00458,0,0,1-4,4H184a4,4,0,0,0,0,8h24a12.01375,12.01375,0,0,0,12-12V183.99951A4.0002,4.0002,0,0,0,216,179.99951Zm-176-32a4.0002,4.0002,0,0,0,4-4v-32a4,4,0,1,0-8,0v32A4.0002,4.0002,0,0,0,40,147.99951ZM72,212H48a4.00458,4.00458,0,0,1-4-4V183.99951a4,4,0,0,0-8,0V208a12.01375,12.01375,0,0,0,12,12H72a4,4,0,0,0,0-8ZM72,36H48A12.01375,12.01375,0,0,0,36,48V71.99951a4,4,0,0,0,8,0V48a4.00458,4.00458,0,0,1,4-4H72a4,4,0,0,0,0-8Z"></path>{' '}
            </g>
        </svg>
    );
}

export function TableGroupNewSmallIcon() {
    return (
        <svg
            className="icon-table-group-new"
            width="28px"
            height="28px"
            viewBox="0 0 256 256"
            fill="none"
            strokeWidth="10"
            stroke="#ffffff"
        >
            {/* <svg className='icon-table-group-new' width="32px" height="32px" viewBox="0 0 256 256" fill="none" strokeWidth="8.959999999999999" stroke="#ffffff"> */}
            <g>
                {' '}
                <path d="M148,40a4.0002,4.0002,0,0,1-4,4H112a4,4,0,0,1,0-8h32A4.0002,4.0002,0,0,1,148,40Zm-4,172H112a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM208,36H184a4,4,0,0,0,0,8h24a4.00458,4.00458,0,0,1,4,4V71.99951a4,4,0,0,0,8,0V48A12.01375,12.01375,0,0,0,208,36Zm8,71.99951a4.0002,4.0002,0,0,0-4,4v32a4,4,0,0,0,8,0v-32A4.0002,4.0002,0,0,0,216,107.99951Zm0,72a4.0002,4.0002,0,0,0-4,4V208a4.00458,4.00458,0,0,1-4,4H184a4,4,0,0,0,0,8h24a12.01375,12.01375,0,0,0,12-12V183.99951A4.0002,4.0002,0,0,0,216,179.99951Zm-176-32a4.0002,4.0002,0,0,0,4-4v-32a4,4,0,1,0-8,0v32A4.0002,4.0002,0,0,0,40,147.99951ZM72,212H48a4.00458,4.00458,0,0,1-4-4V183.99951a4,4,0,0,0-8,0V208a12.01375,12.01375,0,0,0,12,12H72a4,4,0,0,0,0-8ZM72,36H48A12.01375,12.01375,0,0,0,36,48V71.99951a4,4,0,0,0,8,0V48a4.00458,4.00458,0,0,1,4-4H72a4,4,0,0,0,0-8Z"></path>{' '}
            </g>
        </svg>
    );
}

export function LineIcon() {
    return (
        // <svg className='icon-line' width="29px" height="29px" viewBox="0 0 24 24"><g strokeLinecap="round" strokeLinejoin="round"></g><g><path d="M3.293,20.707a1,1,0,0,1,0-1.414l16-16a1,1,0,1,1,1.414,1.414l-16,16A1,1,0,0,1,3.293,20.707Z"></path></g></svg>
        <svg
            className="icon-line"
            width="26px"
            height="26px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2L20 2C21.1046 2 22 2.89543 22 4V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V5.39343L3.72798 21.6655C3.33746 22.056 2.70429 22.056 2.31377 21.6655C1.92324 21.2749 1.92324 20.6418 2.31377 20.2512L18.565 4L12 4Z"
                    fill="#ffffff"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function LineIconNew() {
    return (
        <svg
            className="icon-line-new"
            width="35px"
            height="37px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform="rotate(45)matrix(-1, 0, 0, -1, 0, 0)"
        >
            <g>
                <path
                    d="M7.07615 16.6173C7.23093 16.2436 7.59557 16 8.00003 16H10.5V3C10.5 2.44772 10.9477 2 11.5 2H12.5C13.0523 2 13.5 2.44772 13.5 3V16H16C16.4045 16 16.7691 16.2436 16.9239 16.6173C17.0787 16.991 16.9931 17.4211 16.7071 17.7071L12.7071 21.7071C12.3166 22.0976 11.6834 22.0976 11.2929 21.7071L7.29292 17.7071C7.00692 17.4211 6.92137 16.991 7.07615 16.6173Z"
                    fill="#000000"
                ></path>
            </g>
        </svg>
    );
}

export function LineIconNewSmall() {
    return (
        <svg
            className="icon-line-new"
            width="34px"
            height="34px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform="rotate(45)matrix(-1, 0, 0, -1, 0, 0)"
        >
            <g>
                <path
                    d="M7.07615 16.6173C7.23093 16.2436 7.59557 16 8.00003 16H10.5V3C10.5 2.44772 10.9477 2 11.5 2H12.5C13.0523 2 13.5 2.44772 13.5 3V16H16C16.4045 16 16.7691 16.2436 16.9239 16.6173C17.0787 16.991 16.9931 17.4211 16.7071 17.7071L12.7071 21.7071C12.3166 22.0976 11.6834 22.0976 11.2929 21.7071L7.29292 17.7071C7.00692 17.4211 6.92137 16.991 7.07615 16.6173Z"
                    fill="#000000"
                ></path>
            </g>
        </svg>
    );
}

export function CodeBlockIcon() {
    return (
        <svg
            className="icon-code-block"
            width="32px"
            height="32px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g>
                <path d="M10.3 8.24a.75.75 0 01-.04 1.06L7.352 12l2.908 2.7a.75.75 0 11-1.02 1.1l-3.5-3.25a.75.75 0 010-1.1l3.5-3.25a.75.75 0 011.06.04zm3.44 1.06a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.908-2.7-2.908-2.7z"></path>
                <path
                    fillRule="evenodd"
                    d="M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0120.25 22H3.75A1.75 1.75 0 012 20.25V3.75zm1.75-.25a.25.25 0 00-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 00.25-.25V3.75a.25.25 0 00-.25-.25H3.75z"
                ></path>
            </g>
        </svg>
    );
}

export function NosqlCollectionIcon() {
    return (
        <svg
            className="icon-collection"
            width="32px"
            height="32px"
            viewBox="0 0 32 32"
            id="icon"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path d="M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"></path>
                {/* <rect id="_Transparent_Rectangle_" data-name="<Transparent Rectangle>" className="cls-1" width="32" height="32"></rect> */}
            </g>
        </svg>
    );
}

export function NosqlDocumentIcon() {
    return (
        <svg
            className="icon-document"
            width="32px"
            height="32px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M7 8H17M7 12H17M7 16H13M4 4H20V20H4V4Z"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function UndoIconNew() {
    return (
        <svg
            className="icon-undo-new"
            width="31px"
            height="33px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M5 9.5C8.5 9.5 11.5 9.5 15 9.5C15.1615 9.5 19 9.5 19 13.5C19 18 15.2976 18 15 18C12 18 10 18 7 18"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M8.5 13C7.13317 11.6332 6.36683 10.8668 5 9.5C6.36683 8.13317 7.13317 7.36683 8.5 6"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function RedoIconNew() {
    return (
        <svg
            className="icon-redo-new"
            width="31px"
            height="33px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M19 9.5C15.5 9.5 12.5 9.5 9 9.5C8.83847 9.5 5 9.5 5 13.5C5 18 8.70237 18 9 18C12 18 14 18 17 18"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M15.5 13C16.8668 11.6332 17.6332 10.8668 19 9.5C17.6332 8.13317 16.8668 7.36683 15.5 6"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function FitToZoomIcon() {
    return (
        <svg
            className="icon-fit-to-zoom"
            width="30px"
            height="32px"
            viewBox="0 0 22 22"
            fill="#000000"
        >
            <g
                transform="translate(-544.571 -742.934)"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M547.571 745.934v4h1v-3h3v-1h-3z"></path>
                <path d="M562.571 757.934v3h-3v1h4v-4z"></path>
                <path d="M563.571 745.934v4h-1v-3h-3v-1h3z"></path>
                <path d="M548.571 757.934v3h3v1h-4v-4z"></path>
                <path
                    d="M6 6v10h10V6H6zm1 1h8v8H7V7z"
                    transform="translate(544.571 742.934)"
                    id="rect4147"
                ></path>
            </g>
        </svg>
    );
}

export function SearchIcon() {
    return (
        <svg
            className="icon-search"
            width="22px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <g id="Interface / Search_Magnifying_Glass">
                    {' '}
                    <path
                        id="Vector"
                        d="M15 15L21 21M10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17Z"
                        stroke="#000000"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function ViewModeIcon() {
    return (
        <svg
            className="icon-view-mode"
            height="26px"
            width="28px"
            viewBox="0 0 512 512"
        >
            <g>
                {' '}
                <g>
                    {' '}
                    <g>
                        {' '}
                        <path d="M496,324.362h-31.702v-60.01c0-8.836-7.164-16-16-16H271.996v-60.714h127.109c8.836,0,16-7.164,16-16V76.235 c0-8.836-7.164-16-16-16h-286.21c-8.836,0-16,7.164-16,16v95.404c0,8.836,7.164,16,16,16h127.101v60.714H63.702 c-8.836,0-16,7.164-16,16v60.01H16c-8.836,0-16,7.164-16,16v95.404c0,8.836,7.164,16,16,16h95.404c8.836,0,16-7.164,16-16v-95.404 c0-8.836-7.164-16-16-16H79.702v-44.01h160.293v44.01h-31.698c-8.836,0-16,7.164-16,16v95.404c0,8.836,7.164,16,16,16h95.404 c8.836,0,16-7.164,16-16v-95.404c0-8.836-7.164-16-16-16h-31.707v-44.01h160.302v44.01h-31.702c-8.836,0-16,7.164-16,16v95.404 c0,8.836,7.164,16,16,16H496c8.836,0,16-7.164,16-16v-95.404C512,331.525,504.836,324.362,496,324.362z M95.404,356.362v63.404H32 v-63.404H95.404z M287.702,356.362v63.404h-63.404v-63.404H287.702z M128.895,155.638V92.235h254.21v63.404H128.895z M480,419.765 h-63.404v-63.404H480V419.765z"></path>{' '}
                    </g>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function LeftSidebarOpenedIcon() {
    return (
        <svg
            className="icon-left-sidebar-open"
            width="22px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M15 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function LeftSidebarClosedIcon() {
    return (
        <svg
            className="icon-left-sidebar-open"
            width="22px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M9 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function LeftPanelOpenIcon() {
    return (
        <svg
            className="icon-left-panel-open"
            width="27px"
            height="27px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M19.25,3.99813 C20.7125481,3.99813 21.9084055,5.13983743 21.9949813,6.58060798 L22,6.74813 L22,17.2518 C22,18.7143481 20.8583111,19.9102055 19.4175241,19.9967813 L19.25,20.0018 L4.75,20.0018 C3.28747111,20.0018 2.09159594,18.8601111 2.00501881,17.4193241 L2,17.2518 L2,6.74813 C2,5.28559148 3.14170743,4.08972523 4.58247798,4.00314877 L4.75,3.99813 L19.25,3.99813 Z M19.25,5.49813 L15.9959,5.49813 L15.9958,18.5018 L19.25,18.5018 C19.89725,18.5018 20.4295391,18.0099641 20.4935469,17.3796125 L20.5,17.2518 L20.5,6.74813 C20.5,6.1009175 20.0081641,5.56859563 19.3778125,5.50458356 L19.25,5.49813 Z M14.4959,5.49813 L4.75,5.49813 C4.10279688,5.49813 3.5704668,5.99000109 3.50645367,6.62032409 L3.5,6.74813 L3.5,17.2518 C3.5,17.89905 3.99187109,18.4313391 4.62219409,18.4953469 L4.75,18.5018 L14.4959,18.5018 L14.4959,5.49813 Z M10.3508,9.14531 L12.85,11.6446 C13.0453,11.8398 13.0453,12.1564 12.85,12.3517 L10.3508,14.8509 C10.1555,15.0462 9.83891,15.0462 9.64365,14.8509 C9.44839,14.6557 9.44839,14.3391 9.64365,14.1438 L11.2892,12.4982 L6.50492,12.5 C6.22877,12.5001 6.00483,12.2763 6.00472993,12.0002 C6.00463,11.724 6.22841,11.5001 6.50455,11.5 L11.2895,11.4982 L9.64365,9.85241 C9.44839,9.65715 9.44839,9.34057 9.64365,9.14531 C9.83891,8.95004 10.1555,8.95004 10.3508,9.14531 Z"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function ExportIcon() {
    return (
        <svg
            className="icon-export"
            width="25px"
            height="27px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M16 11L12 15M12 15L8 11M12 15V3M21 15V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V15"
                    stroke="#000000"
                    strokeWidth="1.85"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function ChangeRequestIcon() {
    return (
        <svg
            className="icon-change-request"
            width="26px"
            height="26px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M5.5 8C6.88071 8 8 6.88071 8 5.5C8 4.11929 6.88071 3 5.5 3C4.11929 3 3 4.11929 3 5.5C3 6.88071 4.11929 8 5.5 8ZM5.5 8V16M5.5 16C4.11929 16 3 17.1193 3 18.5C3 19.8807 4.11929 21 5.5 21C6.88071 21 8 19.8807 8 18.5C8 17.1193 6.88071 16 5.5 16ZM18.5 16V8.7C18.5 7.5799 18.5 7.01984 18.282 6.59202C18.0903 6.21569 17.7843 5.90973 17.408 5.71799C16.9802 5.5 16.4201 5.5 15.3 5.5H12M18.5 16C19.8807 16 21 17.1193 21 18.5C21 19.8807 19.8807 21 18.5 21C17.1193 21 16 19.8807 16 18.5C16 17.1193 17.1193 16 18.5 16ZM12 5.5L14.5 8M12 5.5L14.5 3"
                    stroke="#000000"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function AutoLayoutIcon() {
    return (
        <svg
            className="icon-auto-layout"
            width="24px"
            height="24px"
            viewBox="0 0 32 32"
            id="icon"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <rect x="4" y="26" width="24" height="2"></rect>
                <rect x="4" y="19" width="24" height="2"></rect>
                <path d="M26,6v6H6V6H26m0-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"></path>
            </g>
        </svg>
    );
}

export function DragMenuIcon() {
    return (
        <svg
            className="icon-drag-menu"
            fill="#ffffff"
            width="25px"
            height="25px"
            viewBox="0 0 1920 1920"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M686.211 137.143v-.137l68.572.137H686.21Zm0 1508.571c75.566 0 137.143 61.577 137.143 137.143S761.777 1920 686.211 1920c-75.702 0-137.142-61.577-137.142-137.143s61.44-137.143 137.142-137.143Zm548.572 0c75.566 0 137.143 61.577 137.143 137.143S1310.349 1920 1234.783 1920c-75.703 0-137.143-61.577-137.143-137.143s61.44-137.143 137.143-137.143ZM686.21 1097.143c75.566 0 137.143 61.577 137.143 137.143 0 75.565-61.577 137.143-137.143 137.143-75.702 0-137.142-61.578-137.142-137.143 0-75.566 61.44-137.143 137.142-137.143Zm548.572 0c75.566 0 137.143 61.577 137.143 137.143 0 75.565-61.577 137.143-137.143 137.143-75.703 0-137.143-61.578-137.143-137.143 0-75.566 61.44-137.143 137.143-137.143ZM686.21 548.57c75.566 0 137.143 61.578 137.143 137.143 0 75.566-61.577 137.143-137.143 137.143-75.702 0-137.142-61.577-137.142-137.143 0-75.565 61.44-137.143 137.142-137.143Zm548.572 0c75.566 0 137.143 61.578 137.143 137.143 0 75.566-61.577 137.143-137.143 137.143-75.703 0-137.143-61.577-137.143-137.143 0-75.565 61.44-137.143 137.143-137.143ZM686.21 0c75.566 0 137.143 61.577 137.143 137.143S761.776 274.286 686.21 274.286c-75.702 0-137.142-61.577-137.142-137.143S610.509 0 686.21 0Zm548.503 0c75.566 0 137.143 61.577 137.143 137.143s-61.577 137.143-137.143 137.143c-75.565 0-137.143-61.577-137.143-137.143S1159.15 0 1234.714 0Z"
                    fillRule="evenodd"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function MiniMapIcon() {
    return (
        <svg
            className="icon-mini-map"
            width="20px"
            height="22px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M9 18L2 22V6L9 2M9 18L16 22M9 18V2M16 22L22 18V2L16 6M16 22V6M16 6L9 2"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function DeleteIcon() {
    return (
        <svg
            className="icon-delete"
            width="23px"
            height="23px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
                    stroke="#000000"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function InsertAfterIcon() {
    return (
        <svg
            className="icon-insert-after"
            width="26px"
            height="26px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M12 4C12.5523 4 13 4.44772 13 5V8H16C16.5523 8 17 8.44772 17 9C17 9.55228 16.5523 10 16 10H13V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V10H8C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8H11V5C11 4.44772 11.4477 4 12 4Z"
                    fill="#000000"
                ></path>
                <path
                    // d="M3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19Z"
                    d="M 3 20 C 3 19.4477 3.4477 19 4 19 H 20 C 20.5523 19 21 19.4477 21 20 C 21 20.5523 20.5523 21 20 21 H 4 C 3.4477 21 3 20.5523 3 20 Z"
                    fill="#000000"
                ></path>
            </g>
        </svg>
    );
}

export function InsertBeforeIcon() {
    return (
        <svg
            className="icon-insert-before"
            width="26px"
            height="26px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {/* <path d="M3 5C3 5.55228 3.44772 6 4 6H20C20.5523 6 21 5.55228 21 5C21 4.44772 20.5523 4 20 4H4C3.44772 4 3 4.44772 3 5Z" fill="#000000"></path>
                <path d="M12 20C12.5523 20 13 19.5523 13 19V16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H13V11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V14H8C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H11V19C11 19.5523 11.4477 20 12 20Z" fill="#000000"></path> */}
                <path
                    d="M 3 4 C 3 4.5523 3.4477 5 4 5 H 20 C 20.5523 5 21 4.5523 21 4 C 21 3.4477 20.5523 3 20 3 H 4 C 3.4477 3 3 3.4477 3 4 Z"
                    fill="#000000"
                ></path>
                <path
                    d="M12 20C12.5523 20 13 19.5523 13 19V16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H13V11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V14H8C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H11V19C11 19.5523 11.4477 20 12 20Z"
                    fill="#000000"
                ></path>
            </g>
        </svg>
    );
}

export function CopyIcon() {
    return (
        <svg
            className="icon-copy"
            width="23px"
            height="23px"
            viewBox="0 -0.5 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M16 8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.0799 16 5.2 16H8M11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22Z"
                    stroke="#000000"
                    // strokeWidth="2"
                    strokeWidth="1.85"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function ResizeIcon() {
    return (
        <svg
            className="icon-resize"
            width="24px"
            height="24px"
            viewBox="0 0 512 512"
        >
            <g>
                {' '}
                <g>
                    {' '}
                    <g>
                        {' '}
                        <g>
                            <path d="M335.085,207.085L469.333,72.837V128c0,11.782,9.551,21.333,21.333,21.333S512,139.782,512,128V21.335 c0-0.703-0.037-1.406-0.106-2.107c-0.031-0.316-0.09-0.622-0.135-0.933c-0.054-0.377-0.098-0.755-0.172-1.13 c-0.071-0.358-0.169-0.705-0.258-1.056c-0.081-0.323-0.152-0.648-0.249-0.968c-0.104-0.345-0.234-0.678-0.355-1.015 c-0.115-0.319-0.22-0.641-0.35-0.956c-0.13-0.315-0.284-0.616-0.428-0.923c-0.153-0.324-0.297-0.651-0.467-0.969 c-0.158-0.294-0.337-0.574-0.508-0.86c-0.186-0.311-0.362-0.626-0.565-0.93c-0.211-0.316-0.447-0.613-0.674-0.917 c-0.19-0.253-0.366-0.513-0.568-0.76c-0.443-0.539-0.909-1.058-1.402-1.551c-0.004-0.004-0.007-0.008-0.011-0.012 c-0.004-0.004-0.008-0.006-0.011-0.01c-0.494-0.493-1.012-0.96-1.552-1.403c-0.247-0.203-0.507-0.379-0.761-0.569 c-0.303-0.227-0.6-0.462-0.916-0.673c-0.304-0.203-0.619-0.379-0.931-0.565c-0.286-0.171-0.565-0.35-0.859-0.508 c-0.318-0.17-0.644-0.314-0.969-0.467c-0.307-0.145-0.609-0.298-0.923-0.429c-0.315-0.13-0.637-0.236-0.957-0.35 c-0.337-0.121-0.669-0.25-1.013-0.354c-0.32-0.097-0.646-0.168-0.969-0.249c-0.351-0.089-0.698-0.187-1.055-0.258 c-0.375-0.074-0.753-0.119-1.13-0.173c-0.311-0.044-0.617-0.104-0.933-0.135C492.072,0.037,491.37,0,490.667,0H384 c-11.782,0-21.333,9.551-21.333,21.333c0,11.782,9.551,21.333,21.333,21.333h55.163L304.915,176.915 c-8.331,8.331-8.331,21.839,0,30.17S326.754,215.416,335.085,207.085z"></path>
                            <path d="M176.915,304.915L42.667,439.163V384c0-11.782-9.551-21.333-21.333-21.333C9.551,362.667,0,372.218,0,384v106.667 c0,0.703,0.037,1.405,0.106,2.105c0.031,0.315,0.09,0.621,0.135,0.933c0.054,0.377,0.098,0.756,0.173,1.13 c0.071,0.358,0.169,0.704,0.258,1.055c0.081,0.324,0.152,0.649,0.249,0.969c0.104,0.344,0.233,0.677,0.354,1.013 c0.115,0.32,0.22,0.642,0.35,0.957c0.13,0.315,0.284,0.616,0.429,0.923c0.153,0.324,0.297,0.651,0.467,0.969 c0.158,0.294,0.337,0.573,0.508,0.859c0.186,0.311,0.362,0.627,0.565,0.931c0.211,0.316,0.446,0.612,0.673,0.916 c0.19,0.254,0.366,0.514,0.569,0.761c0.443,0.54,0.91,1.059,1.403,1.552c0.004,0.004,0.006,0.008,0.01,0.011 c0.004,0.004,0.008,0.007,0.012,0.011c0.493,0.492,1.012,0.959,1.551,1.402c0.247,0.203,0.507,0.379,0.76,0.568 c0.304,0.227,0.601,0.463,0.917,0.674c0.303,0.203,0.618,0.379,0.93,0.565c0.286,0.171,0.565,0.35,0.86,0.508 c0.318,0.17,0.645,0.314,0.969,0.467c0.307,0.145,0.609,0.298,0.923,0.428c0.315,0.13,0.636,0.235,0.956,0.35 c0.337,0.121,0.67,0.25,1.015,0.355c0.32,0.097,0.645,0.168,0.968,0.249c0.351,0.089,0.698,0.187,1.056,0.258 c0.375,0.074,0.753,0.118,1.13,0.172c0.311,0.044,0.618,0.104,0.933,0.135c0.7,0.069,1.402,0.106,2.104,0.106 c0,0,0.001,0,0.001,0H128c11.782,0,21.333-9.551,21.333-21.333s-9.551-21.333-21.333-21.333H72.837l134.248-134.248 c8.331-8.331,8.331-21.839,0-30.17S185.246,296.584,176.915,304.915z"></path>
                            <path d="M507.736,503.425c0.226-0.302,0.461-0.598,0.671-0.913c0.204-0.304,0.38-0.62,0.566-0.932 c0.17-0.285,0.349-0.564,0.506-0.857c0.17-0.318,0.315-0.646,0.468-0.971c0.145-0.306,0.297-0.607,0.428-0.921 c0.13-0.315,0.236-0.637,0.35-0.957c0.121-0.337,0.25-0.669,0.354-1.013c0.097-0.32,0.168-0.646,0.249-0.969 c0.089-0.351,0.187-0.698,0.258-1.055c0.074-0.375,0.118-0.753,0.173-1.13c0.044-0.311,0.104-0.617,0.135-0.933 c0.069-0.701,0.106-1.404,0.106-2.107V384c0-11.782-9.551-21.333-21.333-21.333s-21.333,9.551-21.333,21.333v55.163 L335.085,304.915c-8.331-8.331-21.839-8.331-30.17,0s-8.331,21.839,0,30.17l134.248,134.248H384 c-11.782,0-21.333,9.551-21.333,21.333S372.218,512,384,512h106.667c0.703,0,1.405-0.037,2.105-0.106 c0.315-0.031,0.621-0.09,0.933-0.135c0.377-0.054,0.756-0.098,1.13-0.173c0.358-0.071,0.704-0.169,1.055-0.258 c0.324-0.081,0.649-0.152,0.969-0.249c0.344-0.104,0.677-0.233,1.013-0.354c0.32-0.115,0.642-0.22,0.957-0.35 c0.314-0.13,0.615-0.283,0.921-0.428c0.325-0.153,0.653-0.297,0.971-0.468c0.293-0.157,0.572-0.336,0.857-0.506 c0.312-0.186,0.628-0.363,0.932-0.566c0.315-0.211,0.611-0.445,0.913-0.671c0.255-0.191,0.516-0.368,0.764-0.571 c0.535-0.439,1.05-0.903,1.54-1.392c0.008-0.007,0.016-0.014,0.023-0.021s0.014-0.016,0.021-0.023 c0.488-0.49,0.952-1.004,1.392-1.54C507.368,503.941,507.545,503.68,507.736,503.425z"></path>
                            <path d="M72.837,42.667H128c11.782,0,21.333-9.551,21.333-21.333C149.333,9.551,139.782,0,128,0H21.333c0,0-0.001,0-0.001,0 c-0.702,0-1.405,0.037-2.104,0.106c-0.316,0.031-0.622,0.09-0.933,0.135c-0.377,0.054-0.755,0.098-1.13,0.172 c-0.358,0.071-0.705,0.169-1.056,0.258c-0.323,0.081-0.648,0.152-0.968,0.249c-0.345,0.104-0.678,0.234-1.015,0.355 c-0.319,0.115-0.641,0.22-0.956,0.35c-0.315,0.131-0.618,0.284-0.925,0.43c-0.323,0.152-0.65,0.296-0.967,0.466 c-0.295,0.158-0.575,0.338-0.862,0.509C10.106,3.215,9.791,3.39,9.488,3.593c-0.317,0.212-0.615,0.448-0.92,0.676 C8.316,4.458,8.057,4.633,7.812,4.835C6.725,5.727,5.727,6.725,4.835,7.812C4.633,8.057,4.458,8.316,4.269,8.569 c-0.228,0.305-0.464,0.603-0.676,0.92c-0.203,0.303-0.378,0.617-0.564,0.928c-0.171,0.286-0.351,0.567-0.509,0.862 c-0.17,0.317-0.313,0.643-0.466,0.967c-0.145,0.307-0.299,0.61-0.43,0.925c-0.13,0.315-0.235,0.636-0.35,0.956 c-0.121,0.337-0.25,0.67-0.355,1.015c-0.097,0.32-0.168,0.645-0.249,0.968c-0.089,0.351-0.187,0.698-0.258,1.056 c-0.074,0.375-0.118,0.753-0.172,1.13c-0.044,0.311-0.104,0.618-0.135,0.933C0.037,19.928,0,20.63,0,21.333V128 c0,11.782,9.551,21.333,21.333,21.333c11.782,0,21.333-9.551,21.333-21.333V72.837l134.248,134.248 c8.331,8.331,21.839,8.331,30.17,0s8.331-21.839,0-30.17L72.837,42.667z"></path>{' '}
                        </g>{' '}
                    </g>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function DragColumnIcon() {
    return (
        <svg
            className="icon-drag-column"
            width="24px"
            height="24px"
            viewBox="0 0 490 490"
            transform="rotate(90)"
        >
            <g>
                {' '}
                <g>
                    {' '}
                    <g>
                        {' '}
                        <g>
                            {' '}
                            <polygon points="425.8,228.3 354.7,228.3 354.7,261.7 425.8,261.7 386.2,301.4 409.9,325.1 490,245 409.9,164.9 386.2,188.6 "></polygon>{' '}
                            <polygon points="64.2,261.7 135.3,261.7 135.3,228.3 64.2,228.3 103.8,188.6 80.1,164.9 0,245 80.1,325.1 103.8,301.4 "></polygon>{' '}
                            <rect x="178.5" width="50.2" height="490"></rect>{' '}
                            <rect x="269.5" width="50.2" height="490"></rect>{' '}
                        </g>{' '}
                    </g>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function CommentIconNew() {
    return (
        <svg
            className="icon-comment-new"
            width="24px"
            height="24px"
            viewBox="0 -0.5 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {' '}
                <path
                    d="M7 8.5H12M7 12H15M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z"
                    stroke="#000000"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function CircleNoneIcon(props) {
    return (
        <svg
            className={`icon-circle-none ${props.isBorder ? 'border' : ''}`}
            width="27px"
            height="27px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path d="M12.5 2.2a10.3 10.3 0 1 0 10.3 10.3A10.299 10.299 0 0 0 12.5 2.2zm0 1a9.252 9.252 0 0 1 6.203 2.39L5.59 18.703A9.284 9.284 0 0 1 12.5 3.2zm0 18.6a9.252 9.252 0 0 1-6.203-2.39L19.41 6.297A9.284 9.284 0 0 1 12.5 21.8z"></path>
            </g>
        </svg>
    );
}

export function MarkYesIcon() {
    return (
        <svg
            className="icon-mark-yes"
            width="40px"
            height="40px"
            viewBox="0 -1 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M16.0303 10.0303C16.3232 9.73744 16.3232 9.26256 16.0303 8.96967C15.7374 8.67678 15.2626 8.67678 14.9697 8.96967L10.5 13.4393L9.03033 11.9697C8.73744 11.6768 8.26256 11.6768 7.96967 11.9697C7.67678 12.2626 7.67678 12.7374 7.96967 13.0303L9.96967 15.0303C10.2626 15.3232 10.7374 15.3232 11.0303 15.0303L16.0303 10.0303Z"
                    fill="#1C274C"
                ></path>
                {/* <path fillRule="evenodd" clipRule="evenodd" d="M12.0574 1.25H11.9426C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62177 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62177 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z" fill="#1C274C"></path> */}
            </g>
        </svg>
    );
}
export function MarkNoIcon() {
    return (
        <svg
            className="icon-mark-yes"
            width="40px"
            height="40px"
            viewBox="0 -1 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M10.0303 8.96967C9.73741 8.67678 9.26253 8.67678 8.96964 8.96967C8.67675 9.26256 8.67675 9.73744 8.96964 10.0303L10.9393 12L8.96966 13.9697C8.67677 14.2626 8.67677 14.7374 8.96966 15.0303C9.26255 15.3232 9.73743 15.3232 10.0303 15.0303L12 13.0607L13.9696 15.0303C14.2625 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2625 15.0303 13.9697L13.0606 12L15.0303 10.0303C15.3232 9.73746 15.3232 9.26258 15.0303 8.96969C14.7374 8.6768 14.2625 8.6768 13.9696 8.96969L12 10.9394L10.0303 8.96967Z"
                    fill="#1C274C"
                ></path>
                {/* <path fillRule="evenodd" clipRule="evenodd" d="M12.0574 1.25H11.9426C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62177 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62177 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z" fill="#1C274C"></path> */}
            </g>
        </svg>
    );
}

export function ShowMenuIcon() {
    return (
        <svg
            className="icon-show-menu"
            width="36px"
            height="40px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M13 15L16 12M16 12L13 9M16 12H8M7.2 20H16.8C17.9201 20 18.4802 20 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V7.2C20 6.0799 20 5.51984 19.782 5.09202C19.5903 4.71569 19.2843 4.40973 18.908 4.21799C18.4802 4 17.9201 4 16.8 4H7.2C6.0799 4 5.51984 4 5.09202 4.21799C4.71569 4.40973 4.40973 4.71569 4.21799 5.09202C4 5.51984 4 6.07989 4 7.2V16.8C4 17.9201 4 18.4802 4.21799 18.908C4.40973 19.2843 4.71569 19.5903 5.09202 19.782C5.51984 20 6.07989 20 7.2 20Z"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function HideMenuIcon() {
    return (
        <svg
            className="icon-show-menu"
            width="36px"
            height="40px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M11 9L8 12M8 12L11 15M8 12H16M7.2 20H16.8C17.9201 20 18.4802 20 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V7.2C20 6.0799 20 5.51984 19.782 5.09202C19.5903 4.71569 19.2843 4.40973 18.908 4.21799C18.4802 4 17.9201 4 16.8 4H7.2C6.0799 4 5.51984 4 5.09202 4.21799C4.71569 4.40973 4.40973 4.71569 4.21799 5.09202C4 5.51984 4 6.07989 4 7.2V16.8C4 17.9201 4 18.4802 4.21799 18.908C4.40973 19.2843 4.71569 19.5903 5.09202 19.782C5.51984 20 6.07989 20 7.2 20Z"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

// export function HideMenuIcon() {
//     return (
//         <svg className='icon-show-menu' width="35px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g>

// <path d="M3 12C3 4.5885 4.5885 3 12 3C19.4115 3 21 4.5885 21 12C21 19.4115 19.4115 21 12 21C4.5885 21 3 19.4115 3 12Z" stroke="#323232" strokeWidth="2"></path>
// <path d="M8 12L16 12" stroke="#323232" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
// <path d="M11 9L8.08704 11.913V11.913C8.03897 11.961 8.03897 12.039 8.08704 12.087V12.087L11 15" stroke="#323232" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
//         </g></svg>
//     );
// }

// export function DraggableColumnsIcon() {
//     return (
//         <svg className='icon-draggable-columns' width="28px" height="28px" viewBox="0 0 24 24" fill="none" transform="matrix(1, 0, 0, -1, 0, 0)rotate(90)"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g>
//             <path d="M10 20L10 12M10 4L10 12M10 12L3 12M3 12L6 15M3 12L6 9" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
//             <path d="M14 20L14 12M14 4L14 12M14 12L21 12M21 12L18 15M21 12L18 9" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
//         </g></svg>
//     );
// }
// export function DraggableColumnsIcon() {
//     return (
//         <svg className='icon-draggable-columns' width="32px" height="32px" viewBox="2 0 24 24" fill="none" transform="matrix(1, 0, 0, -1, 0, 0)rotate(90)"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g>
//             <path d="M14 20L14 12M14 4L14 12M14 12L21 12M21 12L18 15M21 12L18 9 M10 20L10 12M10 4L10 12 Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
//         </g></svg>
//     );
// }

export function DraggableColumnsIcon() {
    return (
        <svg
            className="icon-draggable-new"
            width="26px"
            height="26px"
            viewBox="0 0.5 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    // d="M 3 19 C 3 18.4477 3.4477 18 4 18 H 20 C 20.5523 18 21 18.4477 21 19 C 21 19.5523 20.5523 20 20 20 H 4 C 3.4477 20 3 19.5523 3 19 Z M 13 13 H 13 V 13 C 13 13.5523 12.5523 14 12 14 C 11.4477 14 11 13.5523 11 13 V 10 H 8 C 7.4477 10 8 10 7 10 V 10 C 7 10 12 4 12 4 L 17 10 L 13 10 L 13 13 Z"
                    d="M 3 20 C 3 19.4477 3.4477 19 4 19 H 20 C 20.5523 19 21 19.4477 21 20 C 21 20.5523 20.5523 21 20 21 H 4 C 3.4477 21 3 20.5523 3 20 Z M 13 13 H 13 V 13 C 13 13.5523 12.5523 14 12 14 C 11.4477 14 11 13.5523 11 13 V 10 H 8 C 7.4477 10 8 10 7 10 V 10 C 7 10 12 5 12 5 L 17 10 L 13 10 L 13 13 Z"
                    fill="#000000"
                ></path>
            </g>
        </svg>
    );
}

export function DraggableColumnsReverseIcon() {
    return (
        <svg
            transform="rotate(180)"
            className="icon-draggable-new-reverse"
            width="26px"
            height="26px"
            viewBox="0 2.5 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    // d="M 3 19 C 3 18.4477 3.4477 18 4 18 H 20 C 20.5523 18 21 18.4477 21 19 C 21 19.5523 20.5523 20 20 20 H 4 C 3.4477 20 3 19.5523 3 19 Z M 13 13 H 13 V 13 C 13 13.5523 12.5523 14 12 14 C 11.4477 14 11 13.5523 11 13 V 10 H 8 C 7.4477 10 8 10 7 10 V 10 C 7 10 12 4 12 4 L 17 10 L 13 10 L 13 13 Z"
                    d="M 3 20 C 3 19.4477 3.4477 19 4 19 H 20 C 20.5523 19 21 19.4477 21 20 C 21 20.5523 20.5523 21 20 21 H 4 C 3.4477 21 3 20.5523 3 20 Z M 13 13 H 13 V 13 C 13 13.5523 12.5523 14 12 14 C 11.4477 14 11 13.5523 11 13 V 10 H 8 C 7.4477 10 8 10 7 10 V 10 C 7 10 12 5 12 5 L 17 10 L 13 10 L 13 13 Z"
                    fill="#000000"
                ></path>
            </g>
        </svg>
    );
}

// export function InsertBeforeIcon() {
//     return (
//         <svg className='icon-insert-after' width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g> <path d="M3 5C3 5.55228 3.44772 6 4 6H20C20.5523 6 21 5.55228 21 5C21 4.44772 20.5523 4 20 4H4C3.44772 4 3 4.44772 3 5Z" fill="#000000"></path> <path d="M12 20C12.5523 20 13 19.5523 13 19V16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H13V11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V14H8C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H11V19C11 19.5523 11.4477 20 12 20Z" fill="#000000"></path> </g></svg>
//     );
// }

export function VisibilityIcon() {
    return (
        <svg
            className="icon-draggable-columns"
            width="30px"
            height="30px"
            viewBox="0 0 24 24"
            fill="none"
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.6484 10.5264L13.4743 13.3523C13.8012 12.9962 14.0007 12.5214 14.0007 12C14.0007 10.8954 13.1053 10 12.0007 10C11.4793 10 11.0045 10.1995 10.6484 10.5264Z"
                    fill="#000000"
                ></path>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1211 18.2422C13.4438 18.4051 12.7343 18.5 12.0003 18.5C9.7455 18.5 7.72278 17.6047 6.14832 16.592C4.56791 15.5755 3.3674 14.3948 2.73665 13.7147C2.11883 13.0485 2.06103 12.0457 2.6185 11.3145C3.05443 10.7428 3.80513 9.84641 4.83105 8.95209L6.24907 10.3701C5.35765 11.1309 4.68694 11.911 4.2791 12.436C4.86146 13.0547 5.90058 14.0547 7.23022 14.9099C8.62577 15.8075 10.2703 16.5 12.0003 16.5C12.1235 16.5 12.2463 16.4965 12.3686 16.4896L14.1211 18.2422ZM15.6656 15.544L17.1427 17.0211C17.3881 16.8821 17.6248 16.7383 17.8522 16.592C19.4326 15.5755 20.6332 14.3948 21.2639 13.7147C21.8817 13.0485 21.9395 12.0457 21.3821 11.3145C20.809 10.563 19.6922 9.25059 18.1213 8.1192C16.5493 6.98702 14.4708 6 12.0003 6C10.229 6 8.65936 6.50733 7.33335 7.21175L8.82719 8.70559C9.78572 8.27526 10.8489 8 12.0003 8C13.9223 8 15.5986 8.76704 16.9524 9.7421C18.2471 10.6745 19.1995 11.7641 19.7215 12.436C19.1391 13.0547 18.1 14.0547 16.7703 14.9099C16.4172 15.137 16.0481 15.3511 15.6656 15.544Z"
                    fill="#000000"
                ></path>
                <path
                    d="M4 5L19 20"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                ></path>
            </g>
        </svg>
    );
}

export function VisibilityNewIcon() {
    return (
        <svg
            className="icon-visibility-new"
            width="27px"
            height="27px"
            viewBox="0 0 24 24"
            fill="none"
            transform="matrix(1, 0, 0, -1, 0, 0)"
        >
            <g>
                <path
                    d="M4.4955 7.44088C3.54724 8.11787 2.77843 8.84176 2.1893 9.47978C0.857392 10.9222 0.857393 13.0778 2.1893 14.5202C3.9167 16.391 7.18879 19 12 19C13.2958 19 14.4799 18.8108 15.5523 18.4977L13.8895 16.8349C13.2936 16.9409 12.6638 17 12 17C7.9669 17 5.18832 14.82 3.65868 13.1634C3.03426 12.4872 3.03426 11.5128 3.65868 10.8366C4.23754 10.2097 4.99526 9.50784 5.93214 8.87753L4.4955 7.44088Z"
                    fill="#ffffff"
                ></path>
                <path
                    d="M8.53299 11.4784C8.50756 11.6486 8.49439 11.8227 8.49439 12C8.49439 13.933 10.0614 15.5 11.9944 15.5C12.1716 15.5 12.3458 15.4868 12.516 15.4614L8.53299 11.4784Z"
                    fill="#ffffff"
                ></path>
                <path
                    d="M15.4661 12.4471L11.5473 8.52829C11.6937 8.50962 11.8429 8.5 11.9944 8.5C13.9274 8.5 15.4944 10.067 15.4944 12C15.4944 12.1515 15.4848 12.3007 15.4661 12.4471Z"
                    fill="#ffffff"
                ></path>
                <path
                    d="M18.1118 15.0928C19.0284 14.4702 19.7715 13.7805 20.3413 13.1634C20.9657 12.4872 20.9657 11.5128 20.3413 10.8366C18.8117 9.18002 16.0331 7 12 7C11.3594 7 10.7505 7.05499 10.1732 7.15415L8.50483 5.48582C9.5621 5.1826 10.7272 5 12 5C16.8112 5 20.0833 7.60905 21.8107 9.47978C23.1426 10.9222 23.1426 13.0778 21.8107 14.5202C21.2305 15.1486 20.476 15.8603 19.5474 16.5284L18.1118 15.0928Z"
                    fill="#ffffff"
                ></path>
                <path
                    d="M2.00789 3.42207C1.61736 3.03155 1.61736 2.39838 2.00789 2.00786C2.39841 1.61733 3.03158 1.61733 3.4221 2.00786L22.0004 20.5862C22.391 20.9767 22.391 21.6099 22.0004 22.0004C21.6099 22.3909 20.9767 22.3909 20.5862 22.0004L2.00789 3.42207Z"
                    fill="#ffffff"
                ></path>
            </g>
        </svg>
    );
}

export function SwapLinesIcon() {
    return (
        <svg
            className="icon-swap-lines"
            width="22px"
            height="36px"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M17 9a1 1 0 01-1-1c0-.551-.448-1-1-1H5.414l1.293 1.293a.999.999 0 11-1.414 1.414l-3-3a.999.999 0 010-1.414l3-3a.997.997 0 011.414 0 .999.999 0 010 1.414L5.414 5H15c1.654 0 3 1.346 3 3a1 1 0 01-1 1zM3 11a1 1 0 011 1c0 .551.448 1 1 1h9.586l-1.293-1.293a.999.999 0 111.414-1.414l3 3a.999.999 0 010 1.414l-3 3a.999.999 0 11-1.414-1.414L14.586 15H5c-1.654 0-3-1.346-3-3a1 1 0 011-1z"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function SwapLinesIconNew() {
    return (
        <svg
            className="icon-swap-lines-new"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform="matrix(-1, 0, 0, 1, 0, 0)"
        >
            <g>
                <path
                    d="M18.5858 7L16.2929 9.29289C15.9024 9.68342 15.9024 10.3166 16.2929 10.7071C16.6834 11.0976 17.3166 11.0976 17.7071 10.7071L21.7071 6.70711C22.0976 6.31658 22.0976 5.68342 21.7071 5.29289L17.7071 1.29289C17.3166 0.902369 16.6834 0.902369 16.2929 1.29289C15.9024 1.68342 15.9024 2.31658 16.2929 2.70711L18.5858 5H7C5.67392 5 4.40215 5.52678 3.46447 6.46447C2.52678 7.40215 2 8.67392 2 10V11C2 11.5523 2.44772 12 3 12C3.55228 12 4 11.5523 4 11V10C4 9.20435 4.31607 8.44129 4.87868 7.87868C5.44129 7.31607 6.20435 7 7 7H18.5858Z"
                    fill="#ffffff"
                ></path>
                <path
                    d="M7.70711 14.7071C8.09763 14.3166 8.09763 13.6834 7.70711 13.2929C7.31658 12.9024 6.68342 12.9024 6.29289 13.2929L2.29289 17.2929C1.90237 17.6834 1.90237 18.3166 2.29289 18.7071L6.29289 22.7071C6.68342 23.0976 7.31658 23.0976 7.70711 22.7071C8.09763 22.3166 8.09763 21.6834 7.70711 21.2929L5.41421 19H17C18.3261 19 19.5979 18.4732 20.5355 17.5355C21.4732 16.5979 22 15.3261 22 14V13C22 12.4477 21.5523 12 21 12C20.4477 12 20 12.4477 20 13V14C20 14.7956 19.6839 15.5587 19.1213 16.1213C18.5587 16.6839 17.7956 17 17 17H5.41421L7.70711 14.7071Z"
                    fill="#ffffff"
                ></path>
            </g>
        </svg>
    );
}

export function IndexIcon({ indexType = '' }) {
    const rombRadius = 6;
    return (
        <svg
            className={`icon-index ${indexType || ''}`}
            width="16px"
            height="16px"
        >
            <polygon
                points={`${rombRadius + 1},1 ${rombRadius * 2 + 1},${rombRadius + 1
                    } ${rombRadius + 1},${rombRadius * 2 + 1} 1,${rombRadius + 1}`}
            />
        </svg>
    );
}

export function LineConnectorEmptyIcon() {
    return (
        <svg
            className="icon-line-connector"
            width="38px"
            height="38px"
            viewBox="-2 -2 36 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path d="M 0 8 L 30 8" fill="#ffffff"></path>
                {/* <path d="M 0 8 L 30 8 M 21 1 L 21 15" fill="#ffffff"></path> */}
                {/* <path d="M 0 8 L 25 8 M 21 1 L 21 15 M 25 8 L 30 8" fill="#ffffff"></path> */}
            </g>
        </svg>
    );
}

export function LineConnectorOneIcon(props) {
    return (
        <svg
            className={`icon-line-connector ${props.isLeft ? 'left' : ''}`}
            width="38px"
            height="38px"
            viewBox="-2 -2 36 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform={props.isLeft ? 'matrix(-1, 0, 0, 1, 0, 0)' : undefined}
        >
            <g>
                <path d="M 0 8 L 30 8 M 21 2 L 21 14" fill="#ffffff"></path>
                {/* <path d="M 0 8 L 30 8 M 21 1 L 21 15" fill="#ffffff"></path> */}
                {/* <path d="M 0 8 L 25 8 M 21 1 L 21 15 M 25 8 L 30 8" fill="#ffffff"></path> */}
            </g>
        </svg>
    );
}

export function LineConnectorManyIcon(props) {
    return (
        <svg
            className={`icon-line-connector ${props.isLeft ? 'left' : ''}`}
            width="38px"
            height="38px"
            viewBox="-2 -2 36 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform={props.isLeft ? 'matrix(-1, 0, 0, 1, 0, 0)' : undefined}
        >
            <g>
                <path
                    d="M 0 8 L 30 8 M 30 2 L 17 8 M 17 8 L 30 14"
                    fill="#ffffff"
                ></path>
            </g>
        </svg>
    );
}

export function LineConnectorOneNullIcon(props) {
    return (
        <svg
            className={`icon-line-connector ${props.isLeft ? 'left' : ''}`}
            width="38px"
            height="38px"
            viewBox="-2 -2 36 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform={props.isLeft ? 'matrix(-1, 0, 0, 1, 0, 0)' : undefined}
        >
            <g>
                {/* <path d="M 0 8 L 30 8 M 21 2 L 21 14 M 15 8 A 1 1 0 0 0 8 8 A 1 1 0 0 0 15 8" fill="#ffffff"></path> */}
                <path
                    d="M 0 8 L 30 8 M 21 2 L 21 14 M 16 8 A 1 1 0 0 0 9 8 A 1 1 0 0 0 16 8"
                    fill="#ffffff"
                ></path>

                {/* <path d="M 0 8 L 30 8 M 21 1 L 21 15" fill="#ffffff"></path> */}
                {/* <path d="M 0 8 L 25 8 M 21 1 L 21 15 M 25 8 L 30 8" fill="#ffffff"></path> */}
            </g>
        </svg>
    );
}

export function LineConnectorManyNullIcon(props) {
    return (
        <svg
            className={`icon-line-connector ${props.isLeft ? 'left' : ''}`}
            width="38px"
            height="38px"
            viewBox="-2 -2 36 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform={props.isLeft ? 'matrix(-1, 0, 0, 1, 0, 0)' : undefined}
        >
            <g>
                {/* <path d="M 0 8 L 30 8 M 30 2 L 18 8 M 18 8 L 30 14 M 15 8 A 1 1 0 0 0 8 8 A 1 1 0 0 0 15 8" fill="#ffffff"></path> */}
                <path
                    d="M 0 8 L 30 8 M 30 2 L 18 8 M 18 8 L 30 14 M 16 8 A 1 1 0 0 0 9 8 A 1 1 0 0 0 16 8"
                    fill="#ffffff"
                ></path>

                {/* <path d="M 0 8 L 30 8 M 21 1 L 21 15" fill="#ffffff"></path> */}
                {/* <path d="M 0 8 L 25 8 M 21 1 L 21 15 M 25 8 L 30 8" fill="#ffffff"></path> */}
            </g>
        </svg>
    );
}

export function LineTypeIcon(props) {
    return (
        <svg
            className="icon-line-connector"
            width="38px"
            height="38px"
            viewBox="-2 -2 36 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform={props.isLeft ? 'matrix(-1, 0, 0, 1, 0, 0)' : undefined}
        >
            <g>
                {props.isDots ? (
                    <path
                        d="M 0 14 L 15 14 M 15 14 L 15 2 M 15 2 L 30 2"
                        fill="#ffffff"
                        strokeDasharray="0.6,4"
                    ></path>
                ) : props.isDashes ? (
                    <path
                        d="M 0 14 L 15 14 M 15 14 L 15 2 M 15 2 L 30 2"
                        fill="#ffffff"
                        strokeDasharray="3.2,4"
                    ></path>
                ) : (
                    <path
                        d="M 0 14 L 15 14 M 15 14 L 15 2 M 15 2 L 30 2"
                        fill="#ffffff"
                    ></path>
                )}

                {/* <path d="M 0 14 L 15 14 M 15 14 L 15 2 M 15 2 L 30 2" fill="#ffffff" strokeDasharray="3.5,4"></path> */}
                {/* <path d="M 0 8 L 30 8 M 21 1 L 21 15" fill="#ffffff"></path> */}
                {/* <path d="M 0 8 L 25 8 M 21 1 L 21 15 M 25 8 L 30 8" fill="#ffffff"></path> */}
            </g>
        </svg>
    );
}

export function ElementBorderIcon(props) {
    return (
        <svg
            className="icon-line-connector border"
            width="36px"
            height="36px"
            viewBox="-4.25 -2 35 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {props.isDots ? (
                    <path
                        d="M 0 8 L 27 8"
                        fill="#ffffff"
                        strokeDasharray="1,4"
                    ></path>
                ) : props.isDashes ? (
                    <path
                        d="M 0 8 L 27 8"
                        fill="#ffffff"
                        strokeDasharray="3.5,4"
                    ></path>
                ) : (
                    <path d="M 0 8 L 27 8" fill="#ffffff"></path>
                )}

                {/* <path d="M 0 14 L 15 14 M 15 14 L 15 2 M 15 2 L 30 2" fill="#ffffff" strokeDasharray="3.5,4"></path> */}
                {/* <path d="M 0 8 L 30 8 M 21 1 L 21 15" fill="#ffffff"></path> */}
                {/* <path d="M 0 8 L 25 8 M 21 1 L 21 15 M 25 8 L 30 8" fill="#ffffff"></path> */}
            </g>
        </svg>
    );
}

// export function LineTypeDashesIcon(props) {
//     return (
//         <svg className='icon-line-connector' width="38px" height="38px" viewBox="-2 -2 45 24" fill="none" xmlns="http://www.w3.org/2000/svg"
//             transform={props.isLeft ? "matrix(-1, 0, 0, 1, 0, 0)" : undefined}
//         >
//             <g>
//                 {/* <path d="M 0 14 L 15 14 M 15 14 L 15 2 M 15 2 L 30 2" fill="#ffffff" strokeDasharray="1,4"></path> */}
//                 <path d="M 0 14 L 3 14 M 8 14 L 11 14 M 16 14 L 19 14 M 20 9.5 L 20 6.5 M 21 2 L 24 2 M 29 2 L 32 2 M 37 2 L 40 2 M 45 2 L 48 2" fill="#ffffff" strokeDasharray="3.5,4"></path>
//                 {/* <path d="M 0 8 L 30 8 M 21 1 L 21 15" fill="#ffffff"></path> */}
//                 {/* <path d="M 0 8 L 25 8 M 21 1 L 21 15 M 25 8 L 30 8" fill="#ffffff"></path> */}
//             </g>
//         </svg >
//     );
// }

// <svg className="icon-swap-lines-new" width="34px" height="34px" viewBox="-2 -2 36 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(-1, 0, 0, 1, 0, 0)"><g>
//     <path d="M 0 8 L 25 8 M 21 0 L 21 16 M 25 8 L 29 8" fill="#ffffff"></path></g></svg>

// // SVG path for connectors to tables
// // { M 0 0 }, { L 20 8 }, { L 0 16 }
// function getSymbolManyLines(connector, direction) {
// 	const lines = []

// 	if (direction === RIGHT) {
// 		lines.push({
// 			type: 'line',
// 			p1: { x: connector.p1.x, y: connector.p1.y - 8 },
// 			p2: { x: connector.p1.x + 20, y: connector.p1.y },
// 		});
// 		lines.push({
// 			type: 'line',
// 			p1: { x: connector.p1.x + 20, y: connector.p1.y },
// 			p2: { x: connector.p1.x, y: connector.p1.y + 8 },
// 		});
// 	} else {
// 		lines.push({
// 			type: 'line',
// 			p1: { x: connector.p1.x, y: connector.p1.y - 8 },
// 			p2: { x: connector.p1.x - 20, y: connector.p1.y },
// 		});
// 		lines.push({
// 			type: 'line',
// 			p1: { x: connector.p1.x - 20, y: connector.p1.y },
// 			p2: { x: connector.p1.x, y: connector.p1.y + 8 },
// 		});
// 	}
// 	return lines;
// }

export function ElementDescriptionIcon() {
    return (
        <svg
            className={`icon-element-description`}
            fill="#fff"
            width="20px"
            height="20px"
            viewBox="0 0 30.956 30.956"
            xmlns="http://www.w3.org/2000/svg"
        // transform={props.isLeft ? "matrix(-1, 0, 0, 1, 0, 0)" : undefined}
        >
            <g transform="translate(-481.972 -322.633)">
                <path className="icon-element-description-frame" d="M509.039,324.633a1.891,1.891,0,0,1,1.889,1.89V349.7a1.891,1.891,0,0,1-1.889,1.89H485.862a1.892,1.892,0,0,1-1.89-1.89V326.523a1.892,1.892,0,0,1,1.89-1.89h23.177m0-2H485.862a3.89,3.89,0,0,0-3.89,3.89V349.7a3.89,3.89,0,0,0,3.89,3.89h23.177a3.889,3.889,0,0,0,3.889-3.89V326.523a3.889,3.889,0,0,0-3.889-3.89Z"></path>
                <path d="M505.105,332.478H489.523a1,1,0,1,1,0-2h15.582a1,1,0,0,1,0,2Z"></path>
                <path d="M505.105,339.188H489.523a1,1,0,1,1,0-2h15.582a1,1,0,0,1,0,2Z"></path>
                <path d="M505.105,345.9H489.523a1,1,0,0,1,0-2h15.582a1,1,0,0,1,0,2Z"></path>
            </g>
        </svg>
    );
}

export function CloseButtonIcon({ width = 24, color = '#eff3f4' }) {
    return (
        <svg
            className={`icon-close-button`}
            width={`${width}px`}
            height={`${width}px`}
            viewBox="0 0 24 24"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path d="M10.59 12L4.54 5.96l1.42-1.42L12 10.59l6.04-6.05 1.42 1.42L13.41 12l6.05 6.04-1.42 1.42L12 13.41l-6.04 6.05-1.42-1.42L10.59 12z"></path>
            </g>
        </svg>
    );
}

export function CloseButtonSmallIcon() {
    return (
        <svg
            className={`icon-close-button`}
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            fill="#eff3f4"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path d="M10.59 12L4.54 5.96l1.42-1.42L12 10.59l6.04-6.05 1.42 1.42L13.41 12l6.05 6.04-1.42 1.42L12 13.41l-6.04 6.05-1.42-1.42L10.59 12z"></path>
            </g>
        </svg>
    );
}

export function BackgroundColorCircleIcon(props) {
    // const strokeValue = props.color === '#c8d9e0' ? 'darkslategray' : '#cfc5c5';
    const strokeValue = props.color === '#c8d9e0' ? '#cfc5c5' : '#dcdcdcff';

    const fillValue =
        props.color === '#ffc65e' // yellow
            ? '#ffc65edb' // yellow, darker
            : props.color == 'grey'
                ? '#464646'
                : props.color;
    return (
        <svg
            className={`icon-background-color-circle`}
            width={`${props.isItem ? 28 : 23}px`}
            height={`${props.isItem ? 28 : 23}px`}
            viewBox="0 0 24 24"
            fill="#eff3f4"
        >
            <g>
                <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke={strokeValue}
                    fill={fillValue}
                    strokeWidth={`${props.isItem ? 1.35 : 1.6}`}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></circle>
            </g>
        </svg>
    );
}

export function BackgroundColorCircleBigIcon(props) {
    // const strokeValue = props.isSelected ? 'blue' : '#ffffff';
    const strokeValue = 'black';

    // const strokeWidth = props.isSelected ? 3 : 1.6;
    // const strokeWidth = 1.6;

    // const radius = props.isSelected ? 13 : 13;


    const strokeWidth = 2.3;
    const radius = props.isSelected ? 12.5 : 12.5;

    // const fillValue = props.color === '#ffc65e' // yellow
    //     ? '#ffc65edb' // yellow, darker
    //     : props.color;

    const fillValue =
        props.color == 'grey'
            ? '#464646'
            : props.color;

    return (
        <svg
            className={`icon-background-color-circle`}
            width={`36px`}
            height={`36px`}
            viewBox="2.25 2.25 34 34"
            fill="#eff3f4"
        >
            <g>
                <circle
                    cx="18.9"
                    cy="18.9"
                    // cx="18.25"
                    // cy="18.25"
                    r={`${radius}`}
                    stroke={strokeValue}
                    fill={fillValue}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></circle>
            </g>
        </svg>
    );
}

export function BackgroundColorCircleBigIconNew(props) {
    const strokeValue = 'black';

    const strokeWidth = 2.3;
    const radius = props.isSelected ? 12.5 : 12.5;

    const fillValue =
        props.color == 'grey'
            ? '#464646'
            : props.color;

    return (
        <svg
            className={`icon-background-color-circle`}
            width={`36px`}
            height={`36px`}
            viewBox="2 2 34 34"
            fill="#eff3f4"
        >
            <g>
                <circle
                    cx="18.9"
                    cy="18.9"
                    // cx="18.25"
                    // cy="18.25"
                    r={`${radius}`}
                    stroke={strokeValue}
                    fill={fillValue}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></circle>
            </g>
        </svg>
    );
}

export function IconBack(props) {
    return (
        <svg
            viewBox="0.5 -0.25 24 24"
            width="32px"
            height="32px"
            fill="#ffffff"
            {...props}
        >
            <g>
                <path
                    className="icon-back"
                    d="M 15.03 6.47 a 0.75 0.75 0 0 1 0 1.06 L 10.56 12 l 4.47 4.47 a 0.75 0.75 0 1 1 -1.06 1.06 l -5 -5 a 0.75 0.75 0 0 1 0 -1.06 l 5 -5 a 0.75 0.75 0 0 1 1.06 0 Z"
                ></path>
            </g>
        </svg>
    );
}

export function FontMonospaceIcon(props) {
    return (
        <svg
            width="25px"
            height="25px"
            viewBox="0 -1.5 24 24"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M2 18H22M2 18L5 15M2 18L5 21M22 18L19 15M22 18L19 21M7 3H17M12 3V14"
                    stroke="#ffffff"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function AlignLeftIcon(props) {
    return (
        <svg
            width="28px"
            height="28px"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M4 18H14M4 14H20M4 10H14M4 6H20"
                    stroke="#ffffff"
                    strokeWidth="1.65"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function AlignRightIcon(props) {
    return (
        <svg
            width="28px"
            height="28px"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M20 18H10M20 14H4M20 10H10M20 6H4"
                    stroke="#ffffff"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function AlignCenterIcon(props) {
    return (
        <svg
            width="28px"
            height="28px"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M17 18H7M20 14H4M17 10H7M20 6H4"
                    stroke="#ffffff"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function AlignTopIcon(props) {
    return (
        <svg
            width="28px"
            height="28px"
            viewBox="0 3.5 24 24"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M 20 14 H 4 M 20 10 H 4 M 20 6 H 4"
                    stroke="#ffffff"
                    strokeWidth="1.65"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function AlignBottomIcon(props) {
    return (
        <svg
            width="28px"
            height="28px"
            viewBox="0 -6.5 24 24"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M 20 14 H 4 M 20 10 H 4 M 20 6 H 4"
                    stroke="#ffffff"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function AlignVerticalCenterIcon(props) {
    return (
        <svg
            width="28px"
            height="28px"
            viewBox="0 -1 24 24"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M 20 14 H 4 M 20 10 H 4 M 20 6 H 4"
                    stroke="#ffffff"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function LinkIcon(props) {
    return (
        <svg
            width="27px"
            height="27px"
            viewBox="0 0 24 24"
            fill="none"
            transform="rotate(-45)"
            {...props}
        >
            <g>
                <path
                    d="M10 16H7C4.79086 16 3 14.2091 3 12V12C3 9.79086 4.79086 8 7 8H10"
                    stroke="#ffffff"
                    strokeWidth="1.55"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
                <path
                    d="M16 12H8"
                    stroke="#ffffff"
                    strokeWidth="1.55"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
                <path
                    d="M14 16H17C19.2091 16 21 14.2091 21 12V12C21 9.79086 19.2091 8 17 8H14"
                    stroke="#ffffff"
                    strokeWidth="1.55"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function BoldTextIcon(props) {
    return (
        <svg
            // width="30px"
            width="29px"
            height="30px"
            viewBox="0 0 30 30"
            fill="#ffffff"
            {...props}
        >
            <g transform="translate(0,-289.0625)">
                <g transform="matrix(1.0198402,0,0,0.98054578,0.09141379,0)">
                    <path
                        className="icon-bold-path"
                        stroke="#000000"
                        strokeWidth="0.55px"
                        d="m 17.529303,309.55212 q 1.827765,0.34436 2.966808,1.35096 1.165531,1.00659 1.165531,3.01978 0,2.94032 -2.119148,4.15883 -2.092659,1.19202 -5.880637,1.19202 H 7.7547308 v -18.35712 h 5.1919132 q 3.867446,0 5.907127,1.11255 2.03968,1.08607 2.03968,3.57606 0,1.61586 -0.980106,2.62245 -0.953617,0.98011 -2.384042,1.32447 z m -5.430318,-5.56277 v 4.26479 h 1.615851 q 2.754893,0 2.754893,-2.22511 0,-1.11255 -0.741702,-1.56287 -0.741702,-0.47681 -2.357553,-0.47681 z m 1.589361,12.13213 q 1.721808,0 2.595957,-0.5033 0.900638,-0.52979 0.900638,-1.93372 0,-2.54298 -3.178722,-2.54298 h -1.907234 v 4.98 z"
                    ></path>
                </g>
            </g>
        </svg>
    );
}

export function TagIcon(props) {
    return (
        <svg
            width="26px"
            height="26px"
            viewBox="0 0 26 26"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M6 7C6 5.34315 7.34315 4 9 4H17C18.6569 4 20 5.34315 20 7V21.0568C20 21.8702 19.0806 22.3433 18.4188 21.8705L13.5812 18.4152C13.2335 18.1668 12.7665 18.1668 12.4188 18.4152L7.58124 21.8705C6.91937 22.3433 6 21.8702 6 21.0568V7Z"
                    stroke="#ffffff"
                    strokeWidth="1.75"
                ></path>
            </g>
        </svg>
    );
}

export function ItalicTextIcon(props) {
    return (
        <svg
            // width="25px"
            width="22px"
            height="25px"
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <g>
                <path
                    stroke="#ffffff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 3L8 17m4-14H8m4 0h4M8 17H4m4 0h4"
                ></path>
            </g>
        </svg>
    );
}

export function UnderlineTextIcon(props) {
    return (
        <svg
            // width="25px"
            width="23px"
            height="25px"
            viewBox="0 -1 24 24" {...props}>
            <g>
                <path
                    d="M4 21H20M18 4V11C18 14.3137 15.3137 17 12 17C8.68629 17 6 14.3137 6 11V4M4 3H8M16 3H20"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}

export function StrikethroughTextIcon(props) {
    return (
        <svg
            // width="27px"
            width="26px"
            height="27px"
            viewBox="0 0 24 24"
            fill="#000000"
            {...props}
        >
            <g>
                <path
                    d="M19,12 C19.5523,12 20,12.4477 20,13 C20,13.51285 19.613973,13.9355092 19.1166239,13.9932725 L19,14 L16.8907,14 C17.1073,14.3274 17.2822,14.6843 17.4085,15.0632 C18.3612872,17.9217574 16.2991816,20.8716985 13.3247561,20.9959339 L13.1295,21 L11.4276,21 C9.33508148,21 7.41547616,19.8615567 6.40836368,18.0415942 L6.29625,17.8286 L6.11406,17.4642 C6.07774,17.3951 6.04927,17.3211 6.02987,17.2436 C5.99808,17.1175 5.99194,16.9887 6.00918,16.8639 C6.04771,16.5852 6.20307,16.3268 6.44999,16.1647 C6.54553,16.1017 6.65252,16.0546 6.76716,16.0272 C6.88516,15.9989 7.00534,15.9929 7.12218,16.0074 C7.41451,16.043 7.6679,16.2048 7.82628,16.4366 L7.86803875,16.5031625 L7.86803875,16.5031625 L8.08511,16.9342 C8.6864885,18.136995 9.88435633,18.918864 11.216254,18.9940439 L11.4276,19 L13.1295,19 C14.843,19 16.053,17.3213 15.5111,15.6957 C15.32165,15.12717 14.935856,14.647416 14.4264722,14.3400543 L14.2522,14.2441 L13.7639,14 L5,14 C4.44772,14 4,13.5523 4,13 C4,12.48715 4.38604429,12.0644908 4.88337975,12.0067275 L5,12 L19,12 Z M12.5723,3 C14.7453,3 16.7319,4.22775 17.7037,6.17137 L17.8849,6.53388 C17.926,6.61173 17.9572,6.69566 17.9766,6.78396 C18.0345,7.04488 17.984,7.31519 17.8448,7.53528 C17.7729,7.64908 17.6772,7.74945 17.5607,7.82816 C17.4608,7.89591 17.348,7.94607 17.2268,7.97418 C16.9685,8.03452 16.7003,7.98813 16.48,7.85433 C16.3558,7.77888 16.2468,7.67563 16.1634,7.54805 L16.1279125,7.48969875 L16.1279125,7.48969875 L15.9148,7.0658 C15.2818,5.79974 13.9878,5 12.5723,5 L10.8705,5 C9.15693,5 7.94698,6.67873 8.48884,8.30432 C8.69939,8.93596 9.15223,9.45809 9.74775,9.75585 L12.236,11 L8.01262,11 C7.35876,10.4645 6.86299,9.75131 6.59147,8.93677 C5.61792,6.01612 7.79182,3 10.8705,3 L12.5723,3 Z"
                    fill="#ffffff"
                >
                    {' '}
                </path>
            </g>
        </svg>
    );
}

export function InfoQuestionIcon(props) {
    return (
        <svg
            className='icon-info'
            fill="white"
            width="27px"
            height="27px"
            // viewBox="1 -3.2 56 56"
            viewBox="0.5 -3.2 56 56"
            {...props}
        >
            <g>
                <path d="M 27.9999 51.9063 C 41.0546 51.9063 51.9063 41.0781 51.9063 28 C 51.9063 14.9453 41.0312 4.0937 27.9765 4.0937 C 14.8983 4.0937 4.0937 14.9453 4.0937 28 C 4.0937 41.0781 14.9218 51.9063 27.9999 51.9063 Z M 27.9999 47.9219 C 16.9374 47.9219 8.1014 39.0625 8.1014 28 C 8.1014 16.9609 16.9140 8.0781 27.9765 8.0781 C 39.0155 8.0781 47.8983 16.9609 47.9219 28 C 47.9454 39.0625 39.0390 47.9219 27.9999 47.9219 Z M 27.5077 32.8516 C 28.6796 32.8516 29.4062 32.1250 29.4062 31.1875 L 29.4062 30.9063 C 29.4062 29.5937 30.1562 28.7734 31.7968 27.6953 C 34.0702 26.1953 35.6874 24.8125 35.6874 22.0234 C 35.6874 18.1094 32.2187 16.0234 28.2343 16.0234 C 24.2030 16.0234 21.5546 17.9219 20.9218 20.0781 C 20.8046 20.4766 20.7109 20.8516 20.7109 21.25 C 20.7109 22.2812 21.5546 22.8672 22.3280 22.8672 C 23.6640 22.8672 23.8749 22.1406 24.6249 21.2734 C 25.3983 19.9844 26.5234 19.2109 28.0936 19.2109 C 30.2265 19.2109 31.6093 20.4063 31.6093 22.2109 C 31.6093 23.8047 30.6249 24.5781 28.5858 25.9844 C 26.8983 27.1563 25.6327 28.3984 25.6327 30.6953 L 25.6327 31.0000 C 25.6327 32.2422 26.3124 32.8516 27.5077 32.8516 Z M 27.4609 39.8594 C 28.8202 39.8594 29.9921 38.7812 29.9921 37.4219 C 29.9921 36.0390 28.8436 34.9844 27.4609 34.9844 C 26.0780 34.9844 24.9296 36.0625 24.9296 37.4219 C 24.9296 38.7578 26.1014 39.8594 27.4609 39.8594 Z"></path>
            </g>
        </svg>
    );
}

// KEY SVG
/* <svg fill="white" stroke="#182955" viewBox="0 0 24 24" width="20">
<path d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z">
</path>
</svg> */


export function OkCheckIcon(props) {
    return (
        <svg
            width="26px"
            height="26px"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <g>
                <path
                    d="M20 7.00018L10 17.0002L5 12.0002"
                    stroke="#e9edf0"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </svg>
    );
}


export function TriggerIcon(props) {
    return (
        <svg width="25px" height="25px" viewBox="0 0 48 48" fill="none" {...props}>
            <g>
                <rect width="48" height="48" fill="white" fillOpacity="0.01"></rect>
                <path d="M18 31H38V5" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M30 21H10V43" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M44 11L38 5L32 11" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M16 37L10 43L4 37" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
            </g>
        </svg>
    );
}


export function GeneratedColumnIcon(props) {
    return (
        <svg width="24.5px" height="24.5px" viewBox="0 0 24 24" {...props}>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="white"
                    // d="M12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM20.2988 8.71517C20.4177 8.89041 20.6163 8.99914 20.83 9H21C22.6569 9 24 10.3431 24 12C24 13.6569 22.6569 15 21 15H20.914C20.6549 15.001 20.4212 15.1558 20.3191 15.3939L20.3149 15.4038C20.2076 15.6469 20.2591 15.9308 20.4371 16.1129L20.4967 16.1725C21.06 16.7352 21.3766 17.4988 21.3766 18.295C21.3766 19.0912 21.06 19.8548 20.4975 20.4167C19.9348 20.98 19.1712 21.2966 18.375 21.2966C17.5788 21.2966 16.8152 20.98 16.2529 20.4171L16.2007 20.3649C16.0108 20.1791 15.7269 20.1276 15.4739 20.2391C15.2358 20.3412 15.081 20.5749 15.08 20.83V21C15.08 22.6569 13.7369 24 12.08 24C10.4231 24 9.08 22.6569 9.08 21L9.08027 20.9334C9.07403 20.6666 8.90531 20.4307 8.59623 20.3149C8.35314 20.2076 8.06922 20.2591 7.88711 20.4371L7.8275 20.4967C7.2648 21.06 6.50123 21.3766 5.705 21.3766C4.90877 21.3766 4.14521 21.06 3.58329 20.4975C3.01996 19.9348 2.70343 19.1712 2.70343 18.375C2.70343 17.5788 3.01996 16.8152 3.58289 16.2529L3.63514 16.2007C3.82095 16.0108 3.87243 15.7269 3.76086 15.4739C3.6588 15.2358 3.42508 15.081 3.17 15.08H3C1.34315 15.08 0 13.7369 0 12.08C0 10.4231 1.34315 9.08 3 9.08L3.06662 9.08027C3.33344 9.07403 3.56934 8.90531 3.68514 8.59623C3.79243 8.35314 3.74095 8.06922 3.56289 7.88711L3.50329 7.8275C2.93996 7.2648 2.62343 6.50123 2.62343 5.705C2.62343 4.90877 2.93996 4.14521 3.5025 3.58329C4.0652 3.01996 4.82877 2.70343 5.625 2.70343C6.42123 2.70343 7.18479 3.01996 7.74711 3.58289L7.79926 3.63514C7.98922 3.82095 8.27314 3.87243 8.51623 3.76514C8.58031 3.73686 8.64699 3.71547 8.71517 3.7012C8.89041 3.58234 8.99914 3.38366 9 3.17V3C9 1.34315 10.3431 0 12 0C13.6569 0 15 1.34315 15 3V3.08601C15.001 3.34508 15.1558 3.5788 15.4038 3.68514C15.6469 3.79243 15.9308 3.74095 16.1129 3.56289L16.1725 3.50329C16.7352 2.93996 17.4988 2.62343 18.295 2.62343C19.0912 2.62343 19.8548 2.93996 20.4167 3.5025C20.98 4.0652 21.2966 4.82877 21.2966 5.625C21.2966 6.42123 20.98 7.18479 20.4171 7.74711L20.3649 7.79926C20.1791 7.98922 20.1276 8.27314 20.2349 8.51623C20.2631 8.58031 20.2845 8.64699 20.2988 8.71517ZM20.91 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H20.826C19.7698 10.9958 18.8169 10.3647 18.4009 9.39393C18.3646 9.30943 18.3403 9.22054 18.3285 9.12979C17.9972 8.18472 18.227 7.12463 18.9429 6.39289L19.0033 6.3325C19.1911 6.14493 19.2966 5.89041 19.2966 5.625C19.2966 5.35959 19.1911 5.10507 19.0025 4.91671C18.8149 4.72894 18.5604 4.62343 18.295 4.62343C18.0296 4.62343 17.7751 4.72894 17.5871 4.91711L17.5193 4.98486C16.7448 5.74239 15.5873 5.95227 14.6061 5.51914C13.6353 5.10306 13.0042 4.1502 13 3.09V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V3.17399C10.9958 4.2302 10.3647 5.18306 9.39393 5.59914C9.30943 5.63536 9.22054 5.65966 9.12979 5.67154C8.18472 6.00284 7.12463 5.77296 6.39289 5.05711L6.3325 4.99671C6.14493 4.80894 5.89041 4.70343 5.625 4.70343C5.35959 4.70343 5.10507 4.80894 4.91671 4.9975C4.72894 5.18507 4.62343 5.43959 4.62343 5.705C4.62343 5.97041 4.72894 6.22493 4.91711 6.41289L4.98486 6.48073C5.74239 7.25516 5.95227 8.41268 5.53854 9.34518C5.16293 10.3664 4.20122 11.0543 3.09 11.08H3C2.44772 11.08 2 11.5277 2 12.08C2 12.6323 2.44772 13.08 3 13.08L3.17399 13.08C4.2302 13.0842 5.18306 13.7153 5.59486 14.6762C6.03227 15.6673 5.82239 16.8248 5.05711 17.6071L4.99671 17.6675C4.80894 17.8551 4.70343 18.1096 4.70343 18.375C4.70343 18.6404 4.80894 18.8949 4.9975 19.0833C5.18507 19.2711 5.43959 19.3766 5.705 19.3766C5.97041 19.3766 6.22493 19.2711 6.41289 19.0829L6.48073 19.0151C7.25516 18.2576 8.41268 18.0477 9.34518 18.4615C10.3664 18.8371 11.0543 19.7988 11.08 20.91V21C11.08 21.5523 11.5277 22 12.08 22C12.6323 22 13.08 21.5523 13.08 21L13.08 20.826C13.0842 19.7698 13.7153 18.8169 14.6762 18.4051C15.6673 17.9677 16.8248 18.1776 17.6071 18.9429L17.6675 19.0033C17.8551 19.1911 18.1096 19.2966 18.375 19.2966C18.6404 19.2966 18.8949 19.1911 19.0833 19.0025C19.2711 18.8149 19.3766 18.5604 19.3766 18.295C19.3766 18.0296 19.2711 17.7751 19.0829 17.5871L19.0151 17.5193C18.2589 16.7461 18.0484 15.5911 18.483 14.6011C18.9002 13.6331 19.8516 13.0042 20.91 13Z"
                    d="M 12 16 C 9.7909 16 8 14.2091 8 12 C 8 9.7909 9.7909 8 12 8 C 14.2091 8 16 9.7909 16 12 C 16 14.2091 14.2091 16 12 16 Z M 12 14 C 13.1046 14 14 13.1046 14 12 C 14 10.8954 13.1046 10 12 10 C 10.8954 10 10 10.8954 10 12 C 10 13.1046 10.8954 14 12 14 Z M 20.2988 8.7152 C 20.4177 8.8904 20.6163 8.9991 20.83 9 H 21 C 24 9 24 9 24 12 C 24 15 24 15 21 15 H 20.914 C 20.6549 15.001 20.4212 15.1558 20.3191 15.3939 L 20.3149 15.4038 C 20.2076 15.6469 20.2591 15.9308 20.4371 16.1129 L 20.4967 16.1725 C 22.25 18.5 22.25 18.5 20.4975 20.4167 C 18.5 22.25 18.5 22.25 16.2529 20.4171 L 16.2007 20.3649 C 16.0108 20.1791 15.7269 20.1276 15.4739 20.2391 C 15.2358 20.3412 15.081 20.5749 15.08 20.83 V 21 C 15.08 24 15.08 24 12.08 24 C 9.08 24 9.08 24 9.08 21 L 9.0803 20.9334 C 9.074 20.6666 8.9053 20.4307 8.5962 20.3149 C 8.3531 20.2076 8.0692 20.2591 7.8871 20.4371 L 7.8275 20.4967 C 5.5 22.25 5.5 22.25 3.5833 20.4975 C 1.75 18.5 1.75 18.5 3.5829 16.2529 L 3.6351 16.2007 C 3.8209 16.0108 3.8724 15.7269 3.7609 15.4739 C 3.6588 15.2358 3.4251 15.081 3.17 15.08 H 3 C 0 15.08 0 15.08 0 12.08 C 0 9.08 0 9.08 3 9.08 L 3.0666 9.0803 C 3.3334 9.074 3.5693 8.9053 3.6851 8.5962 C 3.7924 8.3531 3.741 8.0692 3.5629 7.8871 L 3.5033 7.8275 C 1.75 5.5 1.75 5.5 3.5025 3.5833 C 5.5 1.75 5.5 1.75 7.7471 3.5829 L 7.7993 3.6351 C 7.9892 3.8209 8.2731 3.8724 8.5162 3.7651 C 8.5803 3.7369 8.647 3.7155 8.7152 3.7012 C 8.8904 3.5823 8.9991 3.3837 9 3.17 V 3 C 9 0 9 0 12 0 C 15 0 15 0 15 3 V 3.086 C 15.001 3.3451 15.1558 3.5788 15.4038 3.6851 C 15.6469 3.7924 15.9308 3.741 16.1129 3.5629 L 16.1725 3.5033 C 18.5 1.75 18.5 1.75 20.4167 3.5025 C 22.25 5.5 22.25 5.5 20.4171 7.7471 L 20.3649 7.7993 C 20.1791 7.9892 20.1276 8.2731 20.2349 8.5162 C 20.2631 8.5803 20.2845 8.647 20.2988 8.7152 Z M 20.91 13 H 21 C 21.5523 13 22 12.5523 22 12 C 22 11.4477 21.5523 11 21 11 H 20.826 C 19.7698 10.9958 18.8169 10.3647 18.4009 9.3939 C 18.3646 9.3094 18.3403 9.2205 18.3285 9.1298 C 17.9972 8.1847 18.227 7.1246 18.9429 6.3929 L 19.0033 6.3325 C 19.1911 6.1449 19.2966 5.8904 19.2966 5.625 C 19.2966 5.3596 19.1911 5.1051 19.0025 4.9167 C 18.8149 4.7289 18.5604 4.6234 18.295 4.6234 C 18.0296 4.6234 17.7751 4.7289 17.5871 4.9171 L 17.5193 4.9849 C 16.7448 5.7424 15.5873 5.9523 14.6061 5.5191 C 13.6353 5.1031 13.0042 4.1502 13 3.09 V 3 C 13 2.4477 12.5523 2 12 2 C 11.4477 2 11 2.4477 11 3 V 3.174 C 10.9958 4.2302 10.3647 5.1831 9.3939 5.5991 C 9.3094 5.6354 9.2205 5.6597 9.1298 5.6715 C 8.1847 6.0028 7.1246 5.773 6.3929 5.0571 L 6.3325 4.9967 C 6.1449 4.8089 5.8904 4.7034 5.625 4.7034 C 5.3596 4.7034 5.1051 4.8089 4.9167 4.9975 C 4.7289 5.1851 4.6234 5.4396 4.6234 5.705 C 4.6234 5.9704 4.7289 6.2249 4.9171 6.4129 L 4.9849 6.4807 C 5.7424 7.2552 5.9523 8.4127 5.5385 9.3452 C 5.1629 10.3664 4.2012 11.0543 3.09 11.08 H 3 C 2.4477 11.08 2 11.5277 2 12.08 C 2 12.6323 2.4477 13.08 3 13.08 L 3.174 13.08 C 4.2302 13.0842 5.1831 13.7153 5.5949 14.6762 C 6.0323 15.6673 5.8224 16.8248 5.0571 17.6071 L 4.9967 17.6675 C 4.8089 17.8551 4.7034 18.1096 4.7034 18.375 C 4.7034 18.6404 4.8089 18.8949 4.9975 19.0833 C 5.1851 19.2711 5.4396 19.3766 5.705 19.3766 C 5.9704 19.3766 6.2249 19.2711 6.4129 19.0829 L 6.4807 19.0151 C 7.2552 18.2576 8.4127 18.0477 9.3452 18.4615 C 10.3664 18.8371 11.0543 19.7988 11.08 20.91 V 21 C 11.08 21.5523 11.5277 22 12.08 22 C 12.6323 22 13.08 21.5523 13.08 21 L 13.08 20.826 C 13.0842 19.7698 13.7153 18.8169 14.6762 18.4051 C 15.6673 17.9677 16.8248 18.1776 17.6071 18.9429 L 17.6675 19.0033 C 17.8551 19.1911 18.1096 19.2966 18.375 19.2966 C 18.6404 19.2966 18.8949 19.1911 19.0833 19.0025 C 19.2711 18.8149 19.3766 18.5604 19.3766 18.295 C 19.3766 18.0296 19.2711 17.7751 19.0829 17.5871 L 19.0151 17.5193 C 18.2589 16.7461 18.0484 15.5911 18.483 14.6011 C 18.9002 13.6331 19.8516 13.0042 20.91 13 Z C 20.91 13 20.91 13 20.91 13"
                // d="M 12 16 C 9.7909 16 8 14.2091 8 12 C 8 9.7909 9.7909 8 12 8 C 14.2091 8 16 9.7909 16 12 C 16 14.2091 14.2091 16 12 16 Z M 12 14 C 13.1046 14 14 13.1046 14 12 C 14 10.8954 13.1046 10 12 10 C 10.8954 10 10 10.8954 10 12 C 10 13.1046 10.8954 14 12 14 Z M 20.2988 8.7152 C 20.4177 8.8904 20.6163 8.9991 20.83 9 H 21 C 24 9 24 9 24 12 C 24 15 24 15 21 15 H 20.914 C 20.6549 15.001 20.4212 15.1558 20.3191 15.3939 L 20.3149 15.4038 C 20.2076 15.6469 20.2591 15.9308 20.4371 16.1129 L 20.4967 16.1725 C 22.25 18.5 22.25 18.5 20.4975 20.4167 C 18.5 22.25 18.5 22.25 16.2529 20.4171 L 16.2007 20.3649 C 16.0108 20.1791 15.7269 20.1276 15.4739 20.2391 C 15.2358 20.3412 15.081 20.5749 15.08 20.83 V 21 C 15.08 24 15.08 24 12.08 24 C 9.08 24 9.08 24 9.08 21 L 9.0803 20.9334 C 9.074 20.6666 8.9053 20.4307 8.5962 20.3149 C 8.3531 20.2076 8.0692 20.2591 7.8871 20.4371 L 7.8275 20.4967 C 5.5 22.25 5.5 22.25 3.5833 20.4975 C 1.75 18.5 1.75 18.5 3.5829 16.2529 L 3.6351 16.2007 C 3.8209 16.0108 3.8724 15.7269 3.7609 15.4739 C 3.6588 15.2358 3.4251 15.081 3.17 15.08 H 3 C 0 15.08 0 15.08 0 12.08 C 0 9.08 0 9.08 3 9.08 L 3.0666 9.0803 C 3.3334 9.074 3.5693 8.9053 3.6851 8.5962 C 3.7924 8.3531 3.741 8.0692 3.5629 7.8871 L 3.5033 7.8275 C 1.75 5.5 1.75 5.5 3.5025 3.5833 C 5.5 1.75 5.5 1.75 7.7471 3.5829 L 7.7993 3.6351 C 7.9892 3.8209 8.2731 3.8724 8.5162 3.7651 C 8.5803 3.7369 8.647 3.7155 8.7152 3.7012 C 8.8904 3.5823 8.9991 3.3837 9 3.17 V 3 C 9 0 9 0 12 0 C 15 0 15 0 15 3 V 3.086 C 15.001 3.3451 15.1558 3.5788 15.4038 3.6851 C 15.6469 3.7924 15.9308 3.741 16.1129 3.5629 L 16.1725 3.5033 C 18.5 1.75 18.5 1.75 20.4167 3.5025 C 22.25 5.5 22.25 5.5 20.4171 7.7471 L 20.3649 7.7993 C 20.1791 7.9892 20.1276 8.2731 20.2349 8.5162 C 20.2631 8.5803 20.2845 8.647 20.2988 8.7152 Z M 20.91 13 H 21 C 22 13 22 13 22 12 C 22 11 22 11 21 11 H 20.826 C 19.7698 10.9958 18.8169 10.3647 18.4009 9.3939 C 18.3646 9.3094 18.3403 9.2205 18.3285 9.1298 C 17.9972 8.1847 18.227 7.1246 18.9429 6.3929 L 19.0033 6.3325 C 19.7 5.7 19.7 5.7 19.0025 4.9167 C 18.4 4.2 18.4 4.2 17.5871 4.9171 L 17.5193 4.9849 C 16.7448 5.7424 15.5873 5.9523 14.6061 5.5191 C 13.6353 5.1031 13.0042 4.1502 13 3.09 V 3 C 13 2 13 2 12 2 C 11 2 11 2 11 3 V 3.174 C 10.9958 4.2302 10.3647 5.1831 9.3939 5.5991 C 9.3094 5.6354 9.2205 5.6597 9.1298 5.6715 C 8.1847 6.0028 7.1246 5.773 6.3929 5.0571 L 6.3325 4.9967 C 5.5 4.3 5.5 4.3 4.9167 4.9975 C 4.3 5.65 4.3 5.65 4.9171 6.4129 L 4.9849 6.4807 C 5.7424 7.2552 5.9523 8.4127 5.5385 9.3452 C 5.1629 10.3664 4.2012 11.0543 3.09 11.08 H 3 C 2 11.08 2 11.08 2 12.08 C 2 13.08 2 13.08 3 13.08 L 3.174 13.08 C 4.2302 13.0842 5.1831 13.7153 5.5949 14.6762 C 6.0323 15.6673 5.8224 16.8248 5.0571 17.6071 L 4.9967 17.6675 C 4.2 18.3 4.2 18.3 4.9975 19.0833 C 5.7 19.7 5.7 19.7 6.4129 19.0829 L 6.4807 19.0151 C 7.2552 18.2576 8.4127 18.0477 9.3452 18.4615 C 10.3664 18.8371 11.0543 19.7988 11.08 20.91 V 21 C 11.08 22 11.08 22 12.08 22 C 13.08 22 13.08 22 13.08 21 L 13.08 20.826 C 13.0842 19.7698 13.7153 18.8169 14.6762 18.4051 C 15.6673 17.9677 16.8248 18.1776 17.6071 18.9429 L 17.6675 19.0033 C 18.3 19.7 18.3 19.7 19.0833 19.0025 C 19.7 18.3 19.7 18.3 19.0829 17.5871 L 19.0151 17.5193 C 18.2589 16.7461 18.0484 15.5911 18.483 14.6011 C 18.9002 13.6331 19.8516 13.0042 20.91 13 Z C 20.91 13 20.91 13 20.91 13"
                ></path>
            </g>
        </svg>
    );
}



export function CheckExpressionIcon(props) {
    return (
        <svg
            // width="28px"
            width="27px"
            height="28px" viewBox="0 0 24 24" fill="none" {...props}>
            <g>
                <path
                    d="M19.4845 7C17.8699 4.58803 15.1204 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C14.6655 21 17.0604 19.8412 18.7083 18M16 12.2857L17.8 14L22 10M12 8V13M12 16H12.01"
                    stroke="white"
                    // strokeWidth="1.93"
                    strokeWidth="1.7"
                    strokeLinecap="round" strokeLinejoin="round"></path>
            </g>
        </svg>
    );
}


export function LogoIcon(props) {
    return (
        <svg fill="#000000" width="20px" height="24px" viewBox="0 0 82.626 82.627" style={{ marginLeft: '5px' }} {...props}>
            <path
                d="M5.206,19.956l0.199,42.771c0.003,0.55,0.306,1.054,0.789,1.314l34.161,17.887c0.223,0.119,0.467,0.179,0.711,0.179 c0.001,0,0.002,0,0.003,0c0.103,0.117,0.218,0.227,0.355,0.309c0.236,0.141,0.502,0.212,0.769,0.212 c0.246,0,0.49-0.061,0.712-0.181l33.729-18.292c0.484-0.263,0.787-0.77,0.787-1.319v-44.5c0-0.013-0.005-0.025-0.005-0.039 c-0.001-0.011,0.003-0.021,0.003-0.033c-0.002-0.043-0.019-0.082-0.022-0.124c-0.013-0.082-0.022-0.164-0.047-0.243 c-0.018-0.055-0.041-0.104-0.064-0.157c-0.031-0.07-0.062-0.139-0.104-0.203c-0.031-0.05-0.068-0.095-0.105-0.141 c-0.047-0.058-0.096-0.112-0.152-0.163c-0.044-0.04-0.091-0.076-0.141-0.111c-0.032-0.022-0.059-0.053-0.094-0.073 c-0.032-0.02-0.069-0.028-0.104-0.045c-0.029-0.015-0.052-0.036-0.081-0.049L41.747,0.118c-0.405-0.171-0.864-0.155-1.258,0.042 L6.131,18.071c-0.504,0.254-0.822,0.77-0.825,1.333c0,0.009,0.004,0.017,0.004,0.025C5.249,19.596,5.205,19.772,5.206,19.956z M72.456,18.501l-30.28,16.93L10.111,19.425L41.218,3.151L72.456,18.501z M43.692,78.61V38.021l30.729-17.173v41.09L43.692,78.61z"
                style={{ stroke: '#d9dfe3', fill: '#d9dfe3', strokeWidth: '4.25px' }}
            ></path>
        </svg>
    );
}





export function GithubIcon(props) {
    return (
        <svg className="icon-github" width="24px" height="24px" viewBox="0 0 24 24" style={{ marginRight: '7px', width: '20px' }}>
            <path fill="currentColor" d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5c.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34c-.46-1.16-1.11-1.47-1.11-1.47c-.91-.62.07-.6.07-.6c1 .07 1.53 1.03 1.53 1.03c.87 1.52 2.34 1.07 2.91.83c.09-.65.35-1.09.63-1.34c-2.22-.25-4.55-1.11-4.55-4.92c0-1.11.38-2 1.03-2.71c-.1-.25-.45-1.29.1-2.64c0 0 .84-.27 2.75 1.02c.79-.22 1.65-.33 2.5-.33s1.71.11 2.5.33c1.91-1.29 2.75-1.02 2.75-1.02c.55 1.35.2 2.39.1 2.64c.65.71 1.03 1.6 1.03 2.71c0 3.82-2.34 4.66-4.57 4.91c.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2"></path>
        </svg>
    );
}

export function GoogleIcon(props) {
    return (
        <svg className="icon-google" width="20px" height="20px" viewBox="-0.5 0 48 48" fill="#000000" style={{ marginRight: '7px', width: '16px' }}>
            <path
                d="M9.82727273,24 C9.82727273,22.4757333 10.0804318,21.0144 10.5322727,19.6437333 L2.62345455,13.6042667 C1.08206818,16.7338667 0.213636364,20.2602667 0.213636364,24 C0.213636364,27.7365333 1.081,31.2608 2.62025,34.3882667 L10.5247955,28.3370667 C10.0772273,26.9728 9.82727273,25.5168 9.82727273,24"
                id="Fill-1" fill="#FBBC05"> </path>
            <path
                d="M23.7136364,10.1333333 C27.025,10.1333333 30.0159091,11.3066667 32.3659091,13.2266667 L39.2022727,6.4 C35.0363636,2.77333333 29.6954545,0.533333333 23.7136364,0.533333333 C14.4268636,0.533333333 6.44540909,5.84426667 2.62345455,13.6042667 L10.5322727,19.6437333 C12.3545909,14.112 17.5491591,10.1333333 23.7136364,10.1333333"
                id="Fill-2" fill="#EB4335"> </path>
            <path
                d="M23.7136364,37.8666667 C17.5491591,37.8666667 12.3545909,33.888 10.5322727,28.3562667 L2.62345455,34.3946667 C6.44540909,42.1557333 14.4268636,47.4666667 23.7136364,47.4666667 C29.4455,47.4666667 34.9177955,45.4314667 39.0249545,41.6181333 L31.5177727,35.8144 C29.3995682,37.1488 26.7323182,37.8666667 23.7136364,37.8666667"
                id="Fill-3" fill="#34A853"> </path>
            <path
                d="M46.1454545,24 C46.1454545,22.6133333 45.9318182,21.12 45.6113636,19.7333333 L23.7136364,19.7333333 L23.7136364,28.8 L36.3181818,28.8 C35.6879545,31.8912 33.9724545,34.2677333 31.5177727,35.8144 L39.0249545,41.6181333 C43.3393409,37.6138667 46.1454545,31.6490667 46.1454545,24"
                id="Fill-4" fill="#4285F4"> </path>
        </svg>
    );
}


export function InputEditIcon(props) {
    return (
        <svg className="icon-input-edit" width="42px" height="42px" viewBox="1.75 -0.75 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3785 8.44975L11.4637 15.3647C11.1845 15.6439 10.8289 15.8342 10.4417 15.9117L7.49994 16.5L8.08829 13.5582C8.16572 13.1711 8.35603 12.8155 8.63522 12.5363L15.5501 5.62132M18.3785 8.44975L19.7927 7.03553C20.1832 6.64501 20.1832 6.01184 19.7927 5.62132L18.3785 4.20711C17.988 3.81658 17.3548 3.81658 16.9643 4.20711L15.5501 5.62132M18.3785 8.44975L15.5501 5.62132"
                stroke="grey" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" ></path>
        </svg>
    );
}


export function InputEyeIcon(props) {
    return (
        <svg className="icon-input-eye" width="28px" height="28px" viewBox="0 -1 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.0001 5.25C9.22586 5.25 6.79699 6.91121 5.12801 8.44832C4.28012 9.22922 3.59626 10.0078 3.12442 10.5906C2.88804 10.8825 2.70368 11.1268 2.57736 11.2997C2.51417 11.3862 2.46542 11.4549 2.43187 11.5029C2.41509 11.5269 2.4021 11.5457 2.393 11.559L2.38227 11.5747L2.37911 11.5794L2.10547 12.0132L2.37809 12.4191L2.37911 12.4206L2.38227 12.4253L2.393 12.441C2.4021 12.4543 2.41509 12.4731 2.43187 12.4971C2.46542 12.5451 2.51417 12.6138 2.57736 12.7003C2.70368 12.8732 2.88804 13.1175 3.12442 13.4094C3.59626 13.9922 4.28012 14.7708 5.12801 15.5517C6.79699 17.0888 9.22586 18.75 12.0001 18.75C14.7743 18.75 17.2031 17.0888 18.8721 15.5517C19.72 14.7708 20.4039 13.9922 20.8757 13.4094C21.1121 13.1175 21.2964 12.8732 21.4228 12.7003C21.4859 12.6138 21.5347 12.5451 21.5682 12.4971C21.585 12.4731 21.598 12.4543 21.6071 12.441L21.6178 12.4253L21.621 12.4206L21.6224 12.4186L21.9035 12L21.622 11.5809L21.621 11.5794L21.6178 11.5747L21.6071 11.559C21.598 11.5457 21.585 11.5269 21.5682 11.5029C21.5347 11.4549 21.4859 11.3862 21.4228 11.2997C21.2964 11.1268 21.1121 10.8825 20.8757 10.5906C20.4039 10.0078 19.72 9.22922 18.8721 8.44832C17.2031 6.91121 14.7743 5.25 12.0001 5.25ZM4.29022 12.4656C4.14684 12.2885 4.02478 12.1311 3.92575 12C4.02478 11.8689 4.14684 11.7115 4.29022 11.5344C4.72924 10.9922 5.36339 10.2708 6.14419 9.55168C7.73256 8.08879 9.80369 6.75 12.0001 6.75C14.1964 6.75 16.2676 8.08879 17.8559 9.55168C18.6367 10.2708 19.2709 10.9922 19.7099 11.5344C19.8533 11.7115 19.9753 11.8689 20.0744 12C19.9753 12.1311 19.8533 12.2885 19.7099 12.4656C19.2709 13.0078 18.6367 13.7292 17.8559 14.4483C16.2676 15.9112 14.1964 17.25 12.0001 17.25C9.80369 17.25 7.73256 15.9112 6.14419 14.4483C5.36339 13.7292 4.72924 13.0078 4.29022 12.4656ZM14.25 12C14.25 13.2426 13.2427 14.25 12 14.25C10.7574 14.25 9.75005 13.2426 9.75005 12C9.75005 10.7574 10.7574 9.75 12 9.75C13.2427 9.75 14.25 10.7574 14.25 12ZM15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92898 15.75 8.25005 14.0711 8.25005 12C8.25005 9.92893 9.92898 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12Z" fill="#080341"></path>
        </svg>
    );
}

export function InputEyeCloseIcon(props) {
    return (
        <svg className="icon-input-eye" width="28px" height="28px" viewBox="0 -1 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(-1, 0, 0, 1, 0, 0)">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.5778 13.6334C16.2396 12.1831 15.9738 10.4133 14.7803 9.21976C13.5868 8.02628 11.817 7.76042 10.3667 8.4222L11.5537 9.60918C12.315 9.46778 13.1307 9.69153 13.7196 10.2804C14.3085 10.8693 14.5323 11.6851 14.3909 12.4464L15.5778 13.6334Z" fill="#080341"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M5.86339 7.80781C5.60443 8.02054 5.35893 8.23562 5.12798 8.44832C4.28009 9.22922 3.59623 10.0078 3.1244 10.5906C2.88801 10.8825 2.70365 11.1268 2.57733 11.2997C2.51414 11.3862 2.46539 11.4549 2.43184 11.5029C2.41506 11.5269 2.40207 11.5457 2.39297 11.559L2.38224 11.5747L2.37908 11.5794L2.37806 11.5809L2.09656 12L2.37741 12.4181L2.37806 12.4191L2.37908 12.4206L2.38224 12.4253L2.39297 12.441C2.40207 12.4543 2.41506 12.4731 2.43184 12.4971C2.46539 12.5451 2.51414 12.6138 2.57733 12.7003C2.70365 12.8732 2.88801 13.1175 3.1244 13.4094C3.59623 13.9922 4.28009 14.7708 5.12798 15.5517C6.79696 17.0888 9.22583 18.75 12 18.75C13.3694 18.75 14.6547 18.3452 15.806 17.7504L14.6832 16.6277C13.8289 17.0123 12.9256 17.25 12 17.25C9.80366 17.25 7.73254 15.9112 6.14416 14.4483C5.36337 13.7292 4.72921 13.0078 4.29019 12.4656C4.14681 12.2885 4.02475 12.1311 3.92572 12C4.02475 11.8689 4.14681 11.7115 4.29019 11.5344C4.72921 10.9922 5.36337 10.2708 6.14416 9.55168C6.39447 9.32114 6.65677 9.09369 6.92965 8.87408L5.86339 7.80781ZM17.0705 15.1258C17.3434 14.9063 17.6056 14.6788 17.8559 14.4483C18.6367 13.7292 19.2708 13.0078 19.7099 12.4656C19.8532 12.2885 19.9753 12.1311 20.0743 12C19.9753 11.8689 19.8532 11.7115 19.7099 11.5344C19.2708 10.9922 18.6367 10.2708 17.8559 9.55168C16.2675 8.08879 14.1964 6.75 12 6.75C11.0745 6.75 10.1712 6.98772 9.31694 7.37228L8.1942 6.24954C9.34544 5.65475 10.6307 5.25 12 5.25C14.7742 5.25 17.2031 6.91121 18.8721 8.44832C19.72 9.22922 20.4038 10.0078 20.8757 10.5906C21.112 10.8825 21.2964 11.1268 21.4227 11.2997C21.4859 11.3862 21.5347 11.4549 21.5682 11.5029C21.585 11.5269 21.598 11.5457 21.6071 11.559L21.6178 11.5747L21.621 11.5794L21.622 11.5809L21.9035 12L21.6224 12.4186L21.621 12.4206L21.6178 12.4253L21.6071 12.441C21.598 12.4543 21.585 12.4731 21.5682 12.4971C21.5347 12.5451 21.4859 12.6138 21.4227 12.7003C21.2964 12.8732 21.112 13.1175 20.8757 13.4094C20.4038 13.9922 19.72 14.7708 18.8721 15.5517C18.6412 15.7644 18.3957 15.9794 18.1368 16.1921L17.0705 15.1258Z" fill="#080341"></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M18.75 19.8107L3.75 4.81066L4.81066 3.75L19.8107 18.75L18.75 19.8107Z" fill="#080341"></path>
        </svg>
    );
}

export function InputEyeCloseIconNew(props) {
    return (
        <svg className="icon-input-eye" width="28px" height="28px" viewBox="0 -1 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(-1, 0, 0, 1, 0, 0)">
            <g>
                <path fillRule="evenodd" clipRule="evenodd" d="M15.5778 13.6334C16.2396 12.1831 15.9738 10.4133 14.7803 9.21976C13.5868 8.02628 11.817 7.76042 10.3667 8.4222L11.5537 9.60918C12.315 9.46778 13.1307 9.69153 13.7196 10.2804C14.3085 10.8693 14.5323 11.6851 14.3909 12.4464L15.5778 13.6334Z" fill="#080341"></path>
                <path fillRule="evenodd" clipRule="evenodd" d="M5.86339 7.80781C5.60443 8.02054 5.35893 8.23562 5.12798 8.44832C4.28009 9.22922 3.59623 10.0078 3.1244 10.5906C2.88801 10.8825 2.70365 11.1268 2.57733 11.2997C2.51414 11.3862 2.46539 11.4549 2.43184 11.5029C2.41506 11.5269 2.40207 11.5457 2.39297 11.559L2.38224 11.5747L2.37908 11.5794L2.37806 11.5809L2.09656 12L2.37741 12.4181L2.37806 12.4191L2.37908 12.4206L2.38224 12.4253L2.39297 12.441C2.40207 12.4543 2.41506 12.4731 2.43184 12.4971C2.46539 12.5451 2.51414 12.6138 2.57733 12.7003C2.70365 12.8732 2.88801 13.1175 3.1244 13.4094C3.59623 13.9922 4.28009 14.7708 5.12798 15.5517C6.79696 17.0888 9.22583 18.75 12 18.75C13.3694 18.75 14.6547 18.3452 15.806 17.7504L14.6832 16.6277C13.8289 17.0123 12.9256 17.25 12 17.25C9.80366 17.25 7.73254 15.9112 6.14416 14.4483C5.36337 13.7292 4.72921 13.0078 4.29019 12.4656C4.14681 12.2885 4.02475 12.1311 3.92572 12C4.02475 11.8689 4.14681 11.7115 4.29019 11.5344C4.72921 10.9922 5.36337 10.2708 6.14416 9.55168C6.39447 9.32114 6.65677 9.09369 6.92965 8.87408L5.86339 7.80781ZM17.0705 15.1258C17.3434 14.9063 17.6056 14.6788 17.8559 14.4483C18.6367 13.7292 19.2708 13.0078 19.7099 12.4656C19.8532 12.2885 19.9753 12.1311 20.0743 12C19.9753 11.8689 19.8532 11.7115 19.7099 11.5344C19.2708 10.9922 18.6367 10.2708 17.8559 9.55168C16.2675 8.08879 14.1964 6.75 12 6.75C11.0745 6.75 10.1712 6.98772 9.31694 7.37228L8.1942 6.24954C9.34544 5.65475 10.6307 5.25 12 5.25C14.7742 5.25 17.2031 6.91121 18.8721 8.44832C19.72 9.22922 20.4038 10.0078 20.8757 10.5906C21.112 10.8825 21.2964 11.1268 21.4227 11.2997C21.4859 11.3862 21.5347 11.4549 21.5682 11.5029C21.585 11.5269 21.598 11.5457 21.6071 11.559L21.6178 11.5747L21.621 11.5794L21.622 11.5809L21.9035 12L21.6224 12.4186L21.621 12.4206L21.6178 12.4253L21.6071 12.441C21.598 12.4543 21.585 12.4731 21.5682 12.4971C21.5347 12.5451 21.4859 12.6138 21.4227 12.7003C21.2964 12.8732 21.112 13.1175 20.8757 13.4094C20.4038 13.9922 19.72 14.7708 18.8721 15.5517C18.6412 15.7644 18.3957 15.9794 18.1368 16.1921L17.0705 15.1258Z" fill="#080341"></path>
                <path fillRule="evenodd" clipRule="evenodd" d="M18.75 19.8107L3.75 4.81066L4.81066 3.75L19.8107 18.75L18.75 19.8107Z" fill="#080341"></path>
            </g>
            <g>
                <path style={{ transform: 'matrix(-1, 0, 0, -1, 0, 0) translate(-24px, -24px)' }} fillRule="evenodd" clipRule="evenodd" d="M15.5778 13.6334C16.2396 12.1831 15.9738 10.4133 14.7803 9.21976C13.5868 8.02628 11.817 7.76042 10.3667 8.4222L11.5537 9.60918C12.315 9.46778 13.1307 9.69153 13.7196 10.2804C14.3085 10.8693 14.5323 11.6851 14.3909 12.4464L15.5778 13.6334Z" fill="#080341"></path>
            </g>
        </svg>
    );
}

export function InputEyeClosePart2Icon(props) {
    return (
        <svg className="icon-input-eye" width="28px" height="28px" viewBox="0 -1 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(1, 0, 0, -1, 0, 0)">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.5778 13.6334C16.2396 12.1831 15.9738 10.4133 14.7803 9.21976C13.5868 8.02628 11.817 7.76042 10.3667 8.4222L11.5537 9.60918C12.315 9.46778 13.1307 9.69153 13.7196 10.2804C14.3085 10.8693 14.5323 11.6851 14.3909 12.4464L15.5778 13.6334Z" fill="#080341"></path>
        </svg>
    );
}


export function MacCommandIcon(pros) {
    return (
        <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" style={{ marginRight: '4px' }}>
            <g>
                <path
                    d="M9.3 17.85C9.3 19.5897 7.8897 21 6.15 21C4.4103 21 3 19.5897 3 17.85C3 16.1103 4.4103 14.7 6.15 14.7H17.85C19.5897 14.7 21 16.1103 21 17.85C21 19.5897 19.5897 21 17.85 21C16.1103 21 14.7 19.5897 14.7 17.85V6.15C14.7 4.4103 16.1103 3 17.85 3C19.5897 3 21 4.4103 21 6.15C21 7.8897 19.5897 9.3 17.85 9.3H6.15C4.4103 9.3 3 7.8897 3 6.15C3 4.4103 4.4103 3 6.15 3C7.8897 3 9.3 4.4103 9.3 6.15V17.85Z"
                    stroke="#ffffff" stroke-width="1.75"></path>
            </g>
        </svg>
    )
};
